import ConfigDB from "config/ThemeConfig";

export const Footertext: string = "Copyright 2023 © Universitas Mulawarman";
export const ImgPath: string = "assets/images";
export const Href: string = "#javascript";
export const StarColor = "var(--theme-deafult)";
export const SvgPath: string = "/assets/svg";

// Header
export const Loading: string = "Loading";
export const Emptysearch: string = "Opps!! There are no result found.";
export const Buynow: string = "Buy now !";
export const DontMissOut: string = "Politeknik Kesehatan Kesehatan Kalimantan Timur";
export const Notificationtext: string = "Sistem Perencanaan Anggaran";
export const Somethingyoulove: string = "POLIS - Politeknik Integrated Services";
export const English: string = "English";
export const Deutsch: string = "Deutsch";
export const Español: string = "Español";
export const Français: string = "Français";
export const Português: string = "Português";
export const 简体中文: string = "简体中文";
export const لعربية: string = "لعربية";
export const Applications: string = "Applications";
export const Forms: string = "Forms";
export const Back: string = "Back";
export const Cart: string = "Cart";
export const FurnitureChair: string = "Furniture Chair for Home";
export const OrderTotal: string = "Order Total :";
export const Gotoyourcart: string = "Go to your cart";
export const Checkout: string = "Checkout";
export const Notitications: string = "Notitications";
export const Deliveryprocessing: string = "Delivery processing";
export const OrderComplete: string = "Order Complete";
export const TicketsGenerated: string = "Tickets Generated";
export const DeliveryComplete: string = "Delivery Complete";
export const Checkall: string = "Check all";
export const AddNewBookmark: string = "Add New Bookmark";
export const EmayWalter: string = "Emay Walter";
export const Admin: string = "Admin";
export const Account: string = "Account";
export const Inbox: string = "Inbox";
export const Taskboard: string = "Taskboard";
export const SettingText: string = "Settings";
export const Login: string = "Log in";

export const CheckLayouts: string = "Check layouts";
export const Quickoption: string = "Quick option";
export const TryItRealTime: string = "Try It Real Time";
export const PREVIEWSETTINGS: string = "PREVIEW SETTINGS";
export const Layout_Type: string = "Layout Type";
export const Sidebar_Icon: string = "Sidebar Icon";
export const UnlimitedColor: string = "Unlimited Color";
export const Apply: string = "Apply";
export const Mix_Layout: string = "MixLayout";

// Ui -kits Typography
export const rem25: string = "2.5rem";
export const rem2: string = "2rem";
export const rem175: string = "1.75rem";
export const rem15: string = "1.5rem";
export const rem125: string = "1.25rem";
export const rem1: string = "1rem";
export const h1: string = "<h1></h1>";
export const h2: string = "<h2></h2>";
export const h3: string = "<h3></h3>";
export const h4: string = "<h4></h4>";
export const h5: string = "<h5></h5>";
export const h6: string = "<h6></h6>";
export const Heading1MEGA: string = " Heading 1 (MEGA)";
export const Heading2XL: string = " Heading 2 (XL)";
export const Heading3LARGE: string = "Heading 3 (LARGE)";
export const Heading4MEDIUM: string = "Heading 4 (MEDIUM)";
export const Heading5SMALL: string = "Heading 5 (SMALL)";
export const Heading6: string = "Heading 6";
export const Heading1: string = "Heading 1";
export const SubHeading: string = " Sub Heading";
export const bolder: string = " You can set bolder font weight Heading 1 using";
export const bold: string = " You can set bold font weight Heading 2 using";
export const Mediumbold: string =
  "You can set medium font weight Heading 3 using";
export const normalfont: string =
  "You can set normal font weight Heading 4 using";
export const lightfont: string =
  "You can set light font weight Heading 5 using";
export const fw700: string = "f-w-700";
export const fw600: string = "f-w-600";
export const fw500: string = "f-w-500";
export const fw400: string = "f-w-400";
export const fw300: string = "f-w-300";
export const Unorder_list: string = "Unorder list";
export const Order_list: string = "Order list";
export const UIKits: string = "Ui Kits";
export const BonusUi: string = "Bonus Ui";
export const Animations: string = "Animations";
export const Typography: string = "Typography";
export const Avatars: string = "Avatars";
export const Grid: string = "Grid";
export const Tagpills: string = "Tag & pills";
export const Alert: string = "Alert";
export const Dropdown: string = "Dropdown";
export const Tabs: string = "Tabs";
export const Accordion: string = "Accordion";
export const DisplayText: string =
  " Traditional heading elements are designed to work best in the meat of your page content. When you need a heading to stand out, consider using a";
export const DisplayText2: string =
  "—a larger, slightly more opinionated heading style.";
export const displayheading: string = "display heading";
export const Displayheading: string = "Display heading";
export const Display: string = "Display";
export const Inlinetextelements: string = "Inline text elements";
export const DeletText: string =
  "This line of text is meant to be treated as deleted text.";
export const SmallText: string =
  "This line of text is meant to be treated as no longer accurate.";
export const InerText: string =
  "This line of text is meant to be treated as an addition to the document.";
export const UnderlineText: string =
  "This line of text will render as underlined";
export const ExtraSmalltext: string =
  "This line of text is meant to be treated as fine print.";
export const StrongText: string = "This line rendered as bold text.";
export const ItalicText: string = "This line rendered as italicized text.";
export const MarkText: string = "You can use the mark tag to";
export const highlight: string = "highlight";
export const textd: string = " text.";
export const Additive_Border: string = "Additive Border";
export const Subtractive_Border: string = "Subtractive Border";
export const Additive_Radius: string = "Additive Radius";
export const CustomBorder_radius: string = "Custom Border-radius Class";
export const Border_Color: string = "Border Color";
export const Border_Width: string = "Border-Width";
export const Text_Colors: string = "Text Colors";
export const Dark_Background: string = "Dark Background";
export const Light_Backgrounds: string = "Light Backgrounds";
export const Light_Background: string = "Light Background";
export const Extended_Background: string = "Extended Background Colors";
export const light_card: string = ".light-card";
export const Gridbehavior: string = "Grid behavior";
export const Horizontaltimes: string = "Horizontal at all times";
export const Collapsedtostart: string =
  "Collapsed to start, horizontal above breakpoints";
export const Maxcontainerwidth: string = "Max container width";
export const None: string = "None (auto)";
export const px540: string = "540px";
export const px720: string = "720px";
export const px960: string = "960px";
export const px1140: string = "1140px";
export const px1320: string = "1320px";
export const Classprefix: string = "Class prefix";
export const col: string = ".col-";
export const colsm: string = ".col-sm-";
export const colmd: string = ".col-md-";
export const collg: string = ".col-lg-";
export const colxl: string = ".col-xl-";
export const colxxl: string = ".col-xxl-";
export const ofcolumns: string = "# of columns";
export const Gutterwidth: string = "Gutter width";
export const Gutterwidthno: string = "1.5rem (.75rem on left and right)";
export const Nestable: string = "Nestable";
export const Yes: string = "Yes";
export const Offsets: string = "Offsets";
export const Columnordering: string = "Column ordering";
export const onecolumn: string = "one column";
export const Onecolumn: string = "One column";
export const twocolumn: string = "two column";
export const Twocolumn: string = "Two column";
export const Class: string = "Class";
export const Valueclass: string = "Value of the class";
export const Verticalclass: string = ".align-items-*";
export const VerticalPosition: string =
  " start / center / end / baseline / stretch";
export const HorizontalClass: string = ".justify-content-*";
export const HorizontalPosition: string =
  "start / center / end / around / between";
export const Level1col3: string = "Level 1: .col-3";
export const Level2col5: string = "Level 2: .col-5";
export const Level2col7: string = "Level 2: .col-7";
export const Level1col2: string = "Level 1: .col-2";
export const Level1col10: string = "Level 1: .col-10";
export const Level2col4: string = "Level 2: .col-4";
export const orderClass: string = ".order-*";
export const orderPosition: string = " first / 2 / 3 / 4 / 5 / last";
export const OffsetClass: string = ".offset-*";
export const OffsetStep: string = " 1 / 2 / ... / 11 / 12";
export const BadgesContextual: string = "Badges Contextual Variations";
export const PillsVariations: string = "Pills Contextual Variations";
export const NumberofBadge: string = "Number of Badge";
export const NumberofPills: string = "Number of Pills Tags";
export const BadgeIcons: string = "Badge Tags With Icons";
export const PillsWithIcons: string = "Rounded Pills With Icons";
export const BadgeHeadingsExample: string = "Badge Headings Example";
export const BadgeHeading: string = "Badge Heading";
export const Latest: string = "Latest";
export const Trending: string = "Trending";
export const Logout: string = "Logout";
export const BadgesPartButtons: string = "Badges As Part Buttons";
export const BasicProgressBars: string = "Basic Progress Bars";
export const ProgressStriped: string = "Progress Bars Striped";
export const Progressanimated: string = "Progress Bars animated";
export const Simple: string = "Simple";
export const Upto: string = "Up to ";
export const SimpleText: string = ", Hurry Up Online Shopping";
export const SimpleModalPara: string =
  "Our difficulty in finding regular clothes that was of great quality, comfortable, and didn't impact the environment given way to Creatures of Habit.";
export const ExploreMore: string = "Explore More";
export const Close: string = "Close";
export const SaveChanges: string = "Save Changes";
export const Scrollingcontent: string = "Scrolling content";
export const WedDesigner: string = "Wed Designer";
export const UXDesigner: string = "UX Designer";
export const Oneof: string = "One of ";
export const YouTubes: string = "YouTube's";
export const LightOutlineText: string =
  " most crucial ranking factors is Watch Time.";
export const Welldone: string = "Well done! ";
export const DarkOutlineText: string =
  "You successfully read this important message.";
export const Yourtime: string = "Your time Over after ";
export const minute: string = "minute";
export const Check: string = "Check";
export const HertText: string = "Oh snap! Change a few things up ";
export const Notificationcheck: string = " Notification check";
export const DarkAlertText: string =
  "Check your update! You should check in on some of those fields below.";
export const LightAlertText: string =
  "Hidden content You should check in on some of those fields below.";
export const Showlivealert: string = "Show live alert";
export const LiveAlertText: string = "Nice, you triggered this alert message!";
export const LeftBarText: string =
  "You can check in on some of those fields below.";
export const Tooltipspopovers: string = "Tooltips and popovers";
export const Popovermodal: string = "Popover in a modal";
export const This: string = "This ";
export const TriggerText: string = " triggers a popover on click.";
export const Thislink: string = "This link";
export const And: string = "and";
export const Thatlink: string = "that link";
export const HoverText: string = " have tooltips on hover.";
export const Tooltipsmodal: string = "Tooltips in a modal";
export const Openmodalforcuba: string = "Open modal for cuba";
export const HurryUp: string = "Hurry Up!";
export const CUBASIGNUP: string = "CUBA SIGN-UP";
export const FirstName: string = "First name";
export const Lastname: string = "Last name";
export const Emailaddress: string = "Email address";
export const Checktext: string =
  "You accept our Terms and Privacy Policy by clicking Submit below.";
export const SignUp: string = "Sign Up";
export const Looksgood: string = "Looks good!";
export const FullScreenModal: string = "Full Screen Modal";
export const Fullscreenmodal: string = "Fullscreen modal";
export const ExtraLargeModal: string = "Extra large Modal";
export const TooltipButtontext: string = "this is amazing content";
export const Large_Modal: string = "large Modal";
export const Small_Modal: string = "Small Modal";
export const Startyourgoals: string = "Start with your goals";
export const FullscreenText: string =
  "We build specialised websites for companies, list them on digital directories, and set up a sales funnel to boost ROI.";
export const WebDesign: string = "Web Design";
export const Fullscreenbelow_sm: string = "Fullscreen below sm";
export const Fullscreenbelow_md: string = "Fullscreen below md";
export const Fullscreenbelow_lg: string = "Fullscreen below lg";
export const Fullscreenbelow_xl: string = "Fullscreen below xl";
export const Fullscreenbelow_xxl: string = "Fullscreen below xxl";
export const Verticallycentered: string = "Vertically centered";
export const CenteredError: string = "Ohh! Something went wrong!";
export const Centeredtext: string =
  "Attackers on malicious activity may trick you into doing something dangrous like installing software or revealing your personal informations.";
export const Openfirstmodal: string = "Open first modal";
export const RemoveaccountText: string =
  "Remove your complete account from your phone or tablet to sign out of the Gmail app.";
export const Connectnewaccount: string = "Connect new account";
export const Cancel: string = "Cancel";
export const Notamember: string = " Not a member?";
export const Register: string = "Register";
export const YesLogout: string = "Yes, Log out";
export const LogoutText: string = "Are you sure want to logout this dashboard?";
export const Alreadyleaving: string = "Already leaving??";
export const Staticbackdropmodal: string = "Static backdrop modal";
export const CubaLogin: string = "Cuba Login";
export const CubaLoginText: string =
  "Fill in your information below to continue.";
export const Email: string = "Email";
export const Password: string = "Password";
export const Captcha: string = "Captcha";
export const Checkmeout: string = "Check me out";
export const Signin: string = "Sign in";
export const ClickOut: string = "Click Out";
export const Modal_1: string = "Modal 1 - ";
export const Modal_2: string = "Modal 2 - ";
export const Modal_3: string = "Modal 3 - ";
export const ResultModal: string = "Result Modal";
export const ProfileModal: string = "Profile Modal";
export const BalanceModal: string = "Balance Modal";
export const BalanceText: string = "Example of cuba dashboard balance card.";
export const TextModal: string = "Example of cuba dashboard profile card.";
export const ResultText: string = "Example of cuba login form.";
export const BrooklynSimmons: string = "Brooklyn Simmons";
export const brooklysimmons: string = "@brookly.simmons";
export const YourBalance: string = "Your Balance";
export const YourTotalBalance = "768,987.90";
export const Cash_Back: string = "Cash Back";
export const Investment_Constant: string = "Investment";
export const Popoverontop: string = "Popover on top";
export const Popoverontoptext: string =
  "Popovers need the tooltip plugin considering that a dependency.";
export const Popovertitle: string = "Popover title";
export const PopoverOffsetText: string =
  "And here's some amazing content. It's very engaging. Right?";
export const Popoveroffset50: string = "Popover offset 50";
export const Popoveroffset_50: string = "Popover offset -50";
export const PopoverOnLeft: string = "Popover On Left";
export const PopoverOnLeftText: string =
  "Popovers are opt-in for effectiveness causes, in this way you have to initialize them yourself.";
export const BasicTooltipText: string = "It's magic please hover me... ";
export const SurpriseText: string = "Surprise!!! Thank you for hovering...";
export const InlineTooltipContent: string = "Inline Tooltip Content";
export const InlineTooltiptext: string =
  "Here, is some content about tooltips that you can set the";
export const tooltip: string = "tooltip";
export const InsideText: string =
  "inside the content with help of tooltip and also you can add";
export const InsideText2: string =
  " .Tooltips helps you to add more and more content. A tooltip is often used to specify extra information about something when the user moves the mouse pointer over an element";
export const Project: string = "Project";
export const App: string = "Apps";
export const Ecommerce: string = "Ecommerce";
export const Crypto: string = "Crypto";
export const Dashboard: string = "Dashboard";
export const Primary: string = "Primary";
export const Dark: string = "Dark";
export const Light: string = "Light";
export const Lighter: string = "Lighter";
export const Widgets: string = "Widgets";
export const General: string = "General";
export const Chart: string = "Charts";
export const Party: string = "Party";
export const PartyList: string = "Party List";
export const Balloons: string = "Balloons";
export const Cake: string = "Cake";
export const Inputs: string = "Inputs";
export const Defaultcheckbox: string = "Default checkbox";
export const Defaultradio: string = "Default radio";
export const DarkNight: string = "Dark Night";
export const Darkmoon: string = "Dark moon";
export const Darkowl: string = "Dark owl";
export const Nightfall: string = "Nightfall";
export const Dropdownform: string = "Dropdown form";
export const Rememberme: string = "Remember me";
export const Text: string = "Text";
export const Textbody: string =
  "Some example text that's free-flowing within the dropdown menu.";
export const BodyText2: string = "And this is more example text. ";
export const Textleft: string = "Text-left";
export const Hello: string = "Hello..";
export const Howareyou: string = "How are you?";
export const Whatareyou: string = "What are you doing?";
export const Warningtop: string = "Warning top";
export const Becareful: string = "Be careful ";
export const Notifications: string = "Notifications";
export const Beware: string = "Beware ";
export const Largebutton: string = "Large button";
export const Smallbutton: string = "Small button";
export const Mediumbutton: string = "Medium button";
export const VeryLargebutton: string = "Very Large button";
export const VerySmallbutton: string = "Very Small button";
export const ExtraSmallbutton: string = "Extra Small button";
export const Extraextrasmall: string = "Extra Extra small";
export const Profile: string = "Profile";
export const Tables: string = "Tables";
export const DataTables: string = "Data Tables";
export const AccordionItem1: string = "Accordion Item 1";
export const AccordionItem2: string = "Accordion Item 2";
export const AccordionItem3: string = "Accordion Item 3";
export const Home: string = "Home";
export const Contact: string = "Contact";
export const Components: string = "Components";
export const Settings: string = "Settings";
export const Pages: string = "Pages";
export const Aboutus: string = "About us";
export const Contactus: string = "Contact us";
export const Blog: string = "Blog";
export const CubaProfile: string = "CUBA Profiles For New Employees:";
export const Webdesigner: string = "Web designer";
export const WebDesigner: string = "Web Designer";
export const UXdesigner: string = "UX designer";
export const IOTdeveloper: string = "IOT developer";
export const User: string = "User";
export const Description: string = "Description";
export const Review: string = "Review";
export const LogoDesign: string = "Logo Design";
export const Web_Design: string = "Web Design & Development ";
export const ECommerce: string = "E-Commerce";
export const SEO: string = "SEO";
export const WowAnimations: string = "Wow Animations";
export const ApexCharts: string = "Apex Charts";
export const StarterKits: string = "Starter Kits";
export const PRODUCT: string = "PRODUCT";
export const PRODUCTDETAILS: string = "PRODUCT DETAILS ";
export const CART: string = "CART ";
export const CHECKOUT: string = "CHECKOUT";
export const JsBehaviorText: string =
  "We provide end to end digital solutions, right from designing your website/application development: Domain, Web Hosting, Email Hosting Registration, Search Engine Optimization and other Internet Marketing, Renewal of Services timely and effectively.";
export const JsBehaviorText2: string =
  "When someone visits your homepage, your design should inspire them to stay. Therefore, your value proposition should be established on the homepage for visitors to select to stay on your website.Building trust, expressing value, and guiding visitors to the next step all depend on a page's design.";
export const CustomScrolltext: string =
  "There are various justifications for customizing a scrollbar. For instance, the default scrollbar can cause an app's user interface to look inconsistent across various operating systems. In this case, having a single style is helpful.";
export const CustomScrolltext2: string =
  "I never had the opportunity to learn about CSS scrollbar customization, but I have always been interested in doing so. I'll take the chance to learn more about them and share my trip in this essay.";
export const CustomScrolltext3: string | JSX.Element = (
  <>
    One crucial point to remember is that, depending on the design, a scrollbar
    may operate either{" "}
    <em className="txt-danger">horizontally or vertically</em> . Additionally,
    it might alter when you work on a website that is global and operates in
    both left-to-right and right-to-left orientations.
  </>
);
export const CustomScrolltext4: string | JSX.Element = (
  <>
    {"I'm quite interested in learning more about"}{" "}
    <em className="txt-danger">custom scrollbars</em> because they are becoming
    more and more common.
  </>
);
export const CustomScrollbar: string = "Custom Scrollbar";
export const SmallScrollText: string = "Solution for Business Transformation";
export const SmallScrollText2: string | JSX.Element = (
  <>
    The Business Transformation Solution programme is a{" "}
    <em className="txt-danger">multi-level engagement program</em> is designed
    to help Small and Medium-Sized Businesses and Startups create a strong,
    well-functioning business organization that produces the best results
    quickly and effectively.
  </>
);
export const SmallScrollText3: string | JSX.Element = (
  <>
    The core of the programme is our internally developed{" "}
    <em className="txt-danger">Business Management model</em>{" "}
    {', "Business Foundation & Management",'} which was tried and true for
    Indian business conditions while drawing inspiration from other successful
    global SME Business Management techniques.
  </>
);
export const BothScrollText: string =
  "You should stay current with all the most recent advances in the business whether you operate as a freelance web designer or for an agency or design studio. You may be sure you're constantly providing the most intelligent and original design solutions by doing this.";
export const BothScrollText2: string =
  "You can keep up with evolving design trends by reading web design blogs. You'll need to be able to comprehend new trends' causes and how they affect user experience. Additionally, you'll discover upgrades to current tools as well as new ones that have recently hit the market.";
export const BothScrollText3: string =
  ". In light of this, we've compiled a comprehensive list of web design blogs that will keep your mind stimulated for the entire year. You won't find any stinkers on this list, so don't worry. We value your time and believe that you should only receive the greatest. Because of this, we've only gathered web design blogs that have recently being updated. Get ready to add numerous subscriptions by creating your Feebly account.";
export const BothScrollText4: string =
  "The internet is teeming with free resources, no matter what stage of your UX journey you're in, and UX design blogs should be your first point of call. The abundance of blogs available, though, can be somewhat of a double-edged sword because there are so many to choose from. How do you decide which blogs are actually worthwhile reading?";
export const BothScrollText5: string =
  "We've collected a selection of the top UX design blogs available right now to spare you hours of scrolling and sorting through search results. We possess:";
export const BothScrollText6: string =
  "If you already work in the UX field, the Inside Design blog has all the information you need to expand your knowledge, especially if you're interested in streamlining your UX teams and procedures and getting a better understanding of the whole product design and development process. This is an excellent location to keep an eye out for the most recent UX trends, tools, resources, and events because they are always adding new stuff.";
export const Latesttrends: string = "Latest trends";
export const ThebestUXdesigner: string = "The best UX designer";
export const Bestwebsiteideas: string = "How to make best website ideas ";
export const BasicColorToasts: string = "Basic Color Toasts";
export const Custom_Directions: string = "Custom Directions";
export const SuccessToast: string = "Success Toast";
export const InfoToast: string = "Info Toast";
export const WarningToast: string = "Warning Toast";
export const DangerToast: string = "Danger Toast";
export const LightToast: string = "Light Toast";
export const DarkToast: string = "Dark Toast";
export const TopLeft: string = "Top-Left";
export const BottomLeft: string = "Bottom-Left";
export const TopCenter: string = "Top-Center";
export const BottomCenter: string = "Bottom-Center";
export const TopRight: string = "Top-Right";
export const BottomRight: string = "Bottom-Right";
export const CustomAutoclose: string = "Custom Autoclose";
export const AutoClose15: string = "Auto Close 15 sec";
export const AutoClose5: string = "Auto Close 5 sec";
export const AutoClose1: string = "Auto Close 1 sec";
export const AutoClose05: string = "Auto Close 0.5 sec";
export const TransitionType: string = "Transition Type";
export const Bounce_Transition: string = "Bounce Transition";
export const SlideTransition: string = "Slide Transition";
export const Zoom_Transition: string = "Zoom Transition";
export const Flip_Transition: string = "Flip Transition";
export const Rating10: string = "1/10 Rating";
export const Moving_rating: string = "Moving Rating";
export const Heart_Rating: string = "Heart Rating";
export const Pill_Rating: string = "Pill Rating";
export const Star_Rating: string = "Star Rating";
export const HalfStar_Rating: string = "Half Star Rating";
export const Square_Rating: string = "Square Rating";
export const ThumbUpDownRate: string = "Thumb Up/Down Rating";
export const WilliamEmail: string = "William@jourrapide.com";
export const January: string = "02 January 1988";
export const BOD: string = "BOD";
export const WilliamJennings: string = "William C. Jennings";
export const ContactUs: string = "Contact Us";
export const Contactno: string = "US 310-273-0666";
export const LibbyStreet: string = "4377 Libby Street Beverly Hills";
export const Follower: string = "Follower";
export const Following: string = "Following";
export const Jan25: string = "25 Jan";
export const Minread6: string = "6 min read";
export const min3ago: string = "3 min ago";
export const min1read: string = "1 min read";
export const hours10ago: string = "10 hours ago";
export const ProfileHead2: string =
  "Wonderful piece that successfully conveys the magnificence of the mountains and the natural world.";
export const ProfileHead2Text: string | JSX.Element = (
  <>
    English Romantic painter, printer, and watercolourist{" "}
    <em className="txt-danger">William C. Jennings</em>{" "}
    {
      "Is most renowned for his expressive colorization, creative landscapes, and stormy, sometimes violent maritime works. However, this moody image of the Devil's Bridge in Switzerland, close to the Gotthard Pass, feels incredibly authentic and accurately depicts historical occasions when Russian general Suvorov crossed the Alps and fought not only far larger enemy troops!"
    }
  </>
);
export const ProfileText2: string | JSX.Element = (
  <>
    {
      "The curved canvas is enclosed in a complex frame that the artist created but that his buddy Gottlieb Christian Kuhn carved. A variety of Christian symbols are depicted on the frame, including the faces of five infant angels, a star, grapes, vines, corn, and God's eye.Many of the Romantic elements and subjects that he would explore throughout his career are present in this work, one of his earliest, most notable of which is the landscape's significant significance. In spite of the altarpiece's inclusion of a crucifix, the emphasis is"
    }
    <a className="txt-danger" href="user-profile.html" target="_blank">
      {" "}
      Read More
    </a>
  </>
);
export const Profile2Text: string =
  "you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet.";
export const Dec09: string = "09 Dec";
export const Min2read: string = "2 min read";
export const ProfileText: string =
  "Nature has a role in our lives. We are a part of everything since we sprang from a seed and the ground, but we are quickly losing the perception that we are animals much like the rest.Is it possible to feel something when you gaze at, appreciate, and hear  tree ? Can you pay attention to the tiny weed, the creeper climbing the wall, the light on  leaves, and the numerous shadows ? All of this must be understood, and one must have a feeling of connectedness with the natural world around them.Despite living in a town, there are still a few trees here and there.The next garden's bloom could not be well-kept.";
export const TextDetail: string =
  "The wind gives life to the planet. This unobservable, enigmatic energy has the power to revitalize a setting.Its absence can cause the world to become serenely motionless.Its strength is scarcely visible on bare mountain summits, but it becomes obvious in woods and on the water.Winds may be violent and even harmful.When we investigate it carefully Nature is not a destination.Home is here.Garry Snyder In a very real sense, our home, or natural environment, is made up of mountains and valleys, the seas and the sky, the sun and the soil, the trees and the flowers.Growing up in the contemporary, civilized environment, it's simple to start believing";
export const Clickit: string = "Click it!";
export const Surprise: string = "Surprise!";
export const Informational: string = "Informational";
export const Warning: string = "Warning";
export const Pikachu: string = "Pikachu";
export const Questionsstate: string = "Questions state";
export const Username: string = "Username";
export const Loginsuccessfully: string = "Login successfully";
export const Dangermode: string = "Danger mode";
export const Alertmode: string = "Alert mode";
export const Timer: string = "Timer";
export const Moviemode: string = "Movie mode";
export const Copytext: string = "Copy text";
export const SimpleAccordionText: string | JSX.Element | JSX.Element[] = (
  <p>
    {" "}
    Web design<em className="txt-danger"> identifies the goals</em> of a website
    or webpage and promotes accessibility for all potential users. This process
    involves organizing content and images across a series of pages and
    integrating applications and other interactive elements{" "}
  </p>
);
export const Webdesignersdo: string = "What do web designers do?";
export const Usewebdesign: string = "What is the use of web design?";
export const Elementswebdesign: string = "What are the elements of web design?";
export const SimpleAccordionText1: string | JSX.Element | JSX.Element[] = (
  <p>
    {" "}
    <strong> Search engine optimization: </strong> Search engine optimization
    (SEO) is a method for improving the chances for a website to be found by
    search engines. Web design codes information in a way that search engines
    can read it. It can boost business because the site shows up on the top
    search result pages, helping people to find it.
    <br />
    <br />
    <strong> Mobile responsiveness:</strong> Mobile responsiveness is the
    feature of a website that allows it to display on a mobile device and adapt
    its layout and proportions to be legible. Web design ensures sites are easy
    to view and navigate from mobile devices. When a website is well-designed
    and mobile-responsive, customers can reach the business with ease.
    <br />
    <br />
    <strong> Improved sales:</strong>Increasing the number of items sold or
    acquiring more active customers are objectives of a compelling website. As
    web design reaches targeted customers and search engines, it helps the
    business make conversions on their site and improve its sales.
  </p>
);
export const SimpleAccordionText2: string | JSX.Element | JSX.Element[] = (
  <p>
    {" "}
    The web design process allows designers to adjust to any preferences and
    provide effective solutions. There are many standard components of every web
    design, including:
    <br />
    --&gt; Layout
    <br />
    --&gt; Images
    <br />
    --&gt; Visual hierarchy
    <br />
    --&gt; Color scheme
    <br />
    --&gt; Typography
    <br />
    --&gt; Navigation
    <br />
    --&gt; Readability
    <br />
    --&gt; Content
  </p>
);
export const Togglefirst: string = "Toggle first element";
export const Togglesecond: string = "Toggle second element";
export const Toggleboth: string = "Toggle both elements";
export const Collapes1Text: string =
  "The collapse JavaScript plugin is used to show and hide content.Buttons or anchors are used as triggers that are mapped to specific elements you toggle.Collapsing an element will animate the height from it's current value to 0. Given how CSS handles animations, you cannot use padding on a collapse element.Instead, use the class as an independent wrapping element.";
export const Collapes2Text: string =
  "This is the first item's accordion body. It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element.These classes control the overall appearance,  well as the showing and hiding via CSS transitions.You can modify any of this with custom CSS or overriding our default variables.";
export const Togglewidthcollapse: string = "Toggle width collapse";
export const Horizontaltext: string =
  "The collapse plugin also supports horizontal collapsing.Add the.collapse - horizontal modifier class to transition the width instead of height and set a width on the immediate child element.Feel free to write your own custom Sass, use inline styles, or use our width utilities.";
export const Linkwithhref: string = "Link with event";
export const ButtonwithEvent: string = "Button with event";
export const CollapesText: string =
  "Some placeholder content for the collapse component. This panel is hidden by default but revealed when the user activates the relevant trigger.";
export const Progress: string = "Progress";
export const Breadcrumb: string = "Breadcrumb";
export const Homegt: string = "Home ->";
export const Tablesgt: string = "Tables ->";
export const Bootstrapgt: string = "Bootstrap Tables ->";
export const BasicTables: string = "Basic Tables";
export const Icons: string = "Icons";
export const Flag_icon: string = "Flag-icon";
export const Gallery: string = "Gallery";
export const Gallery_grid: string = "Gallery-grid";
export const Default: string = "Default";
export const BasicCardText: string | JSX.Element = (
  <>
    Tabs have long been used to show alternative views of the same group of
    information tabs in software. Known as
    <em className="txt-danger">“module tabs”</em> , these are still used today
    in web sites. For instance, airline companies such as Ryanair, easyJet and
    AirMalta use module tabs to enable the user to switch between bookings for
    flights, hotels and car hire.
  </>
);
export const FlatCardText: string | JSX.Element = (
  <>
    A navigation bar is a particularly important feature because it allows
    visitors to quickly and easily find
    <em className="txt-danger"> important pages on your website</em> , like your
    blog, product pages, pricing, contact info, and documentation. This improves
    the chances of visitors browsing your site longer, which can boost your page
    views and reduce your bounce rate.
  </>
);
export const ShadowCardText: string | JSX.Element = (
  <>
    {" "}
    <strong>Visit Us: </strong> 2600 Hollywood Blvd,Florida, United States-
    33020
    <br />
    <strong>Mail Us:</strong>contact@us@gmail.com
    <br />
    <strong>Contact Number: </strong>(954) 357-7760
  </>
);
export const IconInHeading: string = " Icon In Heading";
export const IconHeadtext: string | JSX.Element = (
  <>
    Use the any icons for heading. <code>[font-awesome/ico-font/feather]</code>.
  </>
);
export const IconHeadtext2: string | JSX.Element = (
  <>
    <p className="mb-xl-0 mb-sm-4">
      We provide end to end digital solutions, right from designing your
      website/application development: Domain, Web Hosting, Email Hosting
      Registration, Search Engine Optimization and other Internet Marketing,
      Renewal of Services timely and effectively.
    </p>
  </>
);
export const DarkColorCard: string = "Dark Color Card";
export const DarkHeadtext: string | JSX.Element = (
  <>
    Use the <code>.bg-dark </code>color for dark background card.
  </>
);
export const DarkBodytext: string | JSX.Element = (
  <>
    <p>
      {" "}
      <em className="txt-danger fw-bold">Smart headphones</em> — also called
      smart earbuds or hearable — are high-tech in-ear devices that do more than
      transmit audio. These headphones are usually wireless, and they can sync
      up with your phone, tablet, computer or other Bluetooth-enabled device.
      The main appeal of hearables is convenience, as they allow you to complete
      common tasks without directly accessing your phone or computer. Smart
      wireless headphones sync up to other devices using Bluetooth technology,
      and many of their features rely on data from your smartphone or computer.
    </p>
  </>
);
export const Card_Footer: string = "Card Footer";
export const InfoColorHeader: string = "Info Color Header";
export const InfoHeadText: string =
  "By following instructions and adding your own unique twist and style, you may apply your imagination as a web designer. The majority of the tasks you'll be assigned will have a specific due date and work description, but the reason you were employed was because they need a specialist to inject some much-needed creativity.";
export const CubaTheme: string = "Cuba Theme";
export const InfoColorBody: string = "Info Color Body";
export const InfoBodyText: string =
  'It is the responsibility of the UX designer to make a product or service useful, pleasurable, and accessible. The word "user experience" is used by various industries, although it is most frequently related to digital design for websites and mobile applications.There is no need for coding in user experience design.';
export const InfoFooter: string = "Info Color Footer";
export const WebDeveloper: string = "Web Developer";
export const FooterInfotext: string =
  "A programmer who uses the client-server architecture to create World Wide Web applications is known as a web developer. The apps generally employ any general-purpose programming language on the server and HTML, CSS, and JavaScript on the client.";
export const BorderleftText: string | JSX.Element = (
  <>
    {
      "Us Technology offers web & mobile development solutions for all industry verticals.Include a short form using fields that'll help your business understand who's contacting them."
    }
    <br />
    <strong>Visit Us: </strong> 2600 Hollywood Blvd,Florida, United States-
    33020
    <br />
    <strong>Mail Us:</strong>contact@us@gmail.com
    <br />
    <strong>Contact Number: </strong>(954) 357-7760
  </>
);
export const BorderRightText: string =
  "Us Technology offers web & mobile development solutions for all industry verticals.Include a short form using fields that'll help your business understand who's contacting them. ";
export const BorderTopText: string | JSX.Element = (
  <>
    Tabs have long been used to show alternative views of the same group of
    information tabs in software. Known as
    <em className="txt-danger">“module tabs”</em> , these are still used today
    in web sites. For instance, airline companies such as Ryanair, easyJet and
    AirMalta use module tabs to enable the user to switch between bookings for
    flights, hotels and car hire.
  </>
);
export const BorderBottomText: string | JSX.Element = (
  <>
    A navigation bar is a particularly important feature because it allows
    visitors to quickly and easily find
    <em className="txt-danger"> important pages on your website</em> , like your
    blog, product pages, pricing, contact info, and documentation. This improves
    the chances of visitors browsing your site longer, which can boost your page
    views and reduce your bounce rate.
  </>
);
export const TeresaMosteller: string = "Teresa J. Mosteller";
export const GloriaAcheson: string = "Gloria D. Acheson";
export const BryanOwens: string = "Bryan A. Owens";
export const BorderWarningtext: string =
  "known for delivery of useful and usable solutions";
export const BorderWarningtext1: string = "Solve your problem with us";
export const BorderWarningtext2: string = "Certified Professionals";
export const BorderWarningtext3: string = "Growth-Driven ";
export const StellaNowland: string = "Stella Nowland ";
export const LolaStanford: string = "Lola Stanford ";
export const CaitlinCoungeau: string = "Caitlin Coungeau ";
export const GracielaMcClaran: string = "Graciela McClaran ";
export const Freelance: string = "Freelance ";
export const Issue: string = "Issue ";
export const Social: string = "Social ";
export const AbsoluteCard: string = "Absolute Card";
export const AbsolutePrimarytext: string =
  "We provide end to end digital solutions, right from designing your website/application development: Domain, Web Hosting, Email Hosting Registration, Search Engine Optimization and other Internet Marketing, Renewal of Services timely and effectively.";
export const AbsoluteSecondarytext: string =
  "When someone visits your homepage, your design should inspire them to stay. Therefore, your value proposition should be established on the homepage for visitors to select to stay on your website.Building trust, expressing value,to the next step all depend on a page's design.";
export const Hover1text: string = "January 2022- Annual Function";
export const Hover1text2: string = "Largo Febo,10225012-Calvisano BS";
export const Location: string = "Location";
export const Locationtext: string =
  "What a dynamic performance by the eighth-grade students, Let's welcome the ninth-grade kid to the stage.";
export const MollyBoake: string = "Molly Boake";
export const Mollymail: string = "MollyBoake@rhyta.com";
export const Mollytext: string =
  "Next step is to choose a tone of voice for your content type.";
export const Afresher: string = "A fresher's interview is to be conducted";
export const Ofwrrior: string = "Ofwrrior Company";
export const FresherTime: string = "March 2022 - Fresher Interview";
export const USMeeting: string = "US Meeting";
export const Leverton: string = "2209 Leverton Cove RoadSpringfield, MA 01109";
export const LillianGoodfellow: string = "Lillian J. Goodfellow";
export const Lillianpin: string = "239-664-7751s";
export const CarolynSutton: string = "Carolyn A. Sutton";
export const CarolynPin: string = "218-793-6609";
export const UpdatedProduct: string = "Updated Product";
export const Updatetext: string = "Quisque a consequat ante sit amet magna...";
export const Today: string = "Today";
export const AddedBewItems: string = "Added Bew Items";
export const Quisqueaconsequat: string =
  "Quisque a consequat ante sit amet magna...";
export const Tellojust: string = "Tello just like your product";
export const Quisqueconsequat: string =
  "Quisque a consequat ante sit amet magna...";
export const ConferencesText: string =
  "Conferences are intended to bring individuals with similar interests together to discuss problems.";
export const Readmore: string = "Read more";
export const Meet_up: string = "Meet-up";
export const YouMayConnect: string =
  "You may connect with males from all around the world using the friend-forward.";
export const Meetingtext: string =
  "If several languages coalesce the grammar of the resulting simple and regular social networking platform.";
export const Conferencetext2: string =
  "A gathering of two or more people to talk about issues of interest.";
export const Launch_Theme: string = "Launch Theme";
export const LaunchThemeText: string =
  "Responsive Website is the approach that suggests website design and development should respond.";
export const Conference_util: string = "Conference";
export const Meeting_util: string = "Meeting";

// Crypto dashboard
export const Crypto_text: string = "Crypto";
export const GreetingMessage4: string = "Cryptocurrency just got even better.";
export const GreetingMessage4SubMessage: string =
  "Lorem Ipsum is simply dummy text";
export const DepositNow: string = "Deposit Now";
export const TransactionsTitle: string = "Transactions";
export const ActivitiesTitle: string = "Activities";
export const MarketGraphTitle: string = "Market Graph";
export const SeeAllBalance: string = "See All Balance";
export const MyCurrenciesTitle: string = "My Currencies";
export const Trade: string = "Trade";
export const BuyCoins: string = "Buy Coins";
export const SellCoins: string = "Sell Coins";
export const EnterYourMoney: string = "Enter your Money";
export const EnterCoinsConverTedTo: string = " Enter Coins Converted to";
export const EnterCryptoCoins: string = "Enter Crypto Coins";
export const EnterMoneyConvertedTo: string = "Enter Money Converted to";
export const USD: string = "USD";
export const BTC: string = "BTC";
export const LTC: string = "LTC";
export const ETH: string = "ETH";
export const CryptoDropdown: string[] = ["BTC", "ETH", "USD", "LTC"];
export const MyPortfolioTitle: string = "My Portfolio";

// Social dashboard
export const Social_text: string = "Social";
export const BrooklynSimmonsEmail = "@brookly.simmons";
export const HaveYouTriedOur = "Have You Tried Our";
export const MobileApplication = "Mobile Application?";
export const TryNow = "Try Now";
export const InstagramSubscribers = "Instagram Subscribers";
export const InstaGrowth = "75% activity growth";
export const FollowerGenderTitle = "Follower Gender";
export const FacebookCampaignTitle = "Facebook Campaign";
export const Active = "Active";
export const FollowersToday = "Followers today";
export const FollowersGoals = "Followers goals";
export const AllCampaignsTitle = "All Campaigns";

// dashboard
export const Default_Util: string = "Default";
export const Welcometocuba: string = "Welcome to cuba";
export const Welcometext: string = "Here whats happing in your account today";
export const WhatsNew: string = "Whats New !";
export const Earning: string = "Earning";
export const Expense: string = "Expense";
export const OverallBalanceTitle: string = "Overall Balance";
export const RecentOrdersTitle: string = "Recent Orders";
export const WeeklyMonDropdown = ["Weekly", "Monthly", "Yearly"];
export const Cancelled: string = "Cancelled";
export const Delivered: string = "Delivered";
export const LastMonth: string = "Last 6 Month";
export const Activity: string = "Activity";
export const DailyDropdown: string[] = ["Today", "Tomorrow", "Yesterday"];
export const MostPopular: string = "Most Popular";
export const RecentSalesTitle: string = "Recent Sales";
export const Timeline: string = "Timeline";
export const PurchaseNow: string = "Purchase Now";
export const ProAccount: string = "Pro Account ";
export const PrimiumFeatures: string = "to Explore Primium Features";
export const Buy: string = "Buy";
export const TotalUsers: string = "Total Users";
export const FollowersGrowth: string = "Followers Growth";
export const PaperNoteTitle: string = "Paper Note";
export const ViewProject: string = "View project";
export const BlogMessage: string =
  "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit.";
export const Inprogress: string = "Inprogress";
export const Budget: string = "(Budget)";

// E-commerce
export const ECommerceDashboard: string = "E-Commerce";
export const E_Commerce: string = "E-Commerce";
export const TotalBalanceTitle: string = "Total Balance";
export const ThisMonth: string = "this month";
export const TapUpBalance: string = "Tap Up Balance";
export const ValuableCustomerTitle: string = "Valuable Customer";
export const OrderThisMonthTitle: string = "Order This Month";
export const MonthlyProfitsTitle: string = "Monthly Profits";
export const MonthlyProfitsGrowth: string = "Total profit growth of 30%";
export const OrderOverviewTitle: string = "Order Overview";
export const Refunds: string = "Refunds";
export const Order: string = "Order";
export const DiscoverPro: string = "Discover Pro";
export const DiscoverPera: string =
  "Amet minim mollit non deserunt ullamco est sit aliqua dolor ";
export const UpdateNow: string = "Update Now";
export const Visitors: string = " Visitors";
export const TopCategoriesTitle: string = "Top Categories";
export const RecentActivity: string = "Recent Activity";

export const Sidebar_Type: string = "Sidebar Type";
export const Online_course: string = "Online Course";
export const HelloJashmin: string = " Hello Jashmin";
export const welcomeMessage: string =
  "Learn something new every day with world's best courses.Free online courses available.";
export const TodayProgressTitle: string = "Today Progress";
export const TodayProgressMessage: string = "Your Daily Goal Almost Done!";
export const DoYouWantToGet: string = "Do You Want to Get";
export const BetterResults: string = "Better Results?";
export const MoreDetails: string = "More details";
export const LearningOverviewTitle: string = "Learning Overview";
export const LearningOverviewGrowth: string = "75% activity growth";
export const UpcomingEventsTitle: string = "Upcoming Events";
export const ActivityHoursTitle: string = "Activity Hours";
export const MyCourseTitle: string = "My Course";
export const UpcomingScheduleTitle: string = "Upcoming Schedule";
export const Create: string = "Create";
export const ActiveLessonsTitle: string = "Active Lessons";
export const View: string = "View";
export const MutualFriends: string = "Mutual Friends";
export const ActivityFeed: string = "Activity Feed";
export const ActivityLog: string = "Activity Log";
export const PortfolioTitle: string = "Portfolio Title";
export const ViewTitle: string = "Views";

//NFT Dashboard
export const NFTDashboard: string = "NFT";
export const TrendingCreator: string = "Trending Creator";
export const TotalUSD: string = "Total USD";
export const Items: string = "Items";
export const ExploreNftDetail: string =
  "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.";
export const ExploreNft: string =
  "NFTs – the next level of when wealth and ignorance collide.";
export const Explore: string = "Explore";
export const CreateNow: string = "Create Now";
export const Weekly: string = "Weekly";
export const Monthly: string = "Monthly";
export const Yearly: string = "Yearly";
export const TotalOffers: string = "Total Offers";
export const TapToYourBalance: string = "Tap to Your Balance";
export const Income: string = "Income";
export const WeeklySalesStatusHeading: string = "Weekly Sales Status";
export const Course: string = "Course";
export const Sale: string = "Sale";
export const Earnings: string = "Earnings";
export const PlaceBid: string = "Place a Bid";
export const TrendingActionHeading: string = "Trending Action";
export const OwnedBy: string = "Owned by";
export const AuctionTime: string = "Auction Time";
export const CurrentBid: string = "Current Bid";
export const UpgradeYourPlan: string = "Upgrade Your Plan";
export const UpgradeYourPlanParagraph: string =
  "Amet minim mollit non deseru ullamco est.";
export const UpgradeNow: string = "Upgrade Now";
export const TopNFTHeading: string = "Top NFT";
export const Collection: string = "Collection";
export const Volume: string = "Volume";
export const Hours24: string = "24h %";
export const Statistics: string = "Statistics";
export const TotalArtSold: string = "Total art sold";
export const TotalEarning: string = "Total Earning";
export const DropDownOption: string[] = [Weekly, Monthly, Yearly];
export const TrendingNFTHeading: string = "Trending NFT";

//School Management
export const SchoolManagementHeading: string = "School Management";
export const SchoolManage: string = "School Manage";
export const knowledgeLearning: string = "Increase your knowledge by Learning!";
export const knowledgeLearningParagraph: string =
  "The essential way to learn about anything is by reading quality literature!";
export const LearnMore: string = "Learn More";
export const AcademicPerformanceHeading: string = "Academic Performance";
export const SchoolPerformanceHeading: string = "School Performance";
export const Tommorow: string = "Tommorow";
export const Yesterday: string = "Yesterday";
export const DropdownButtonsList: string[] = [Today, Tommorow, Yesterday];
export const EventCalendarHeading: string = "Event Calendar";
export const TodaysTaskHeading: string = "Today's Task";
export const Task: string = "Task";
export const completed: string = "completed";
export const outOf: string = "out of";
export const ClassNumber: string = "Class Number";
export const NoticeBoardHeading: string = "Notice Board";
export const StudentLeaderHeading: string = "Student's Leader";

//forms
export const ValidationFormHeading: string = "Validation Form";
export const BaseInputsHeading: string = "Base Inputs";
export const RadioCheckBoxHeading: string = "Checkbox & Radio";
export const InputGroupsHeading: string = "Input Groups";
export const MegaOptionHeading: string = "Mega Option";
export const DatePickerHeading: string = "Date Picker";
export const FormControlsHeading: string = "Forms Controls";
export const BootstrapTables: string = "Bootstrap Tables";
export const InputMasksHeading: string = "Input Masks";
export const FormWizardHeading: string = "Form Wizard";
export const FormWizard2Heading: string = "Form Wizard 2";
export const FormLayoutHeading: string = "Form Layout";
export const TwoFactorHeading: string = "Two Factor";
export const ClipBoardHeading: string = "Clipboard on text input";
export const ClipBoards: string = "Clipboard";
export const FormWidgetsHeading: string = "Form Widgets";
export const TouchSpinHeading: string = "Touchspin";
export const DateTimePickerHeading: string = "Date Time Picker";
export const Select2Heading: string = "Select 2";
export const SwitchHeading: string = "Switch";
export const TimePickerHeading: string = "Time Picker";
export const LeafletWorldMap = "Leaflet WORLD MAP";
export const LeafletUkMap = "Leaflet UK MAP";
export const LeafletUSAMap = "Leaflet USA MAP";
export const LeafletIndiaMap = "Leaflet India MAP";
export const LeafletAustraliaMap = "Leaflet Australia MAP";
export const JavascriptModeHeading = "Javascript Mode";
export const HTMLModeHeading = "HTML Mode";
export const CSSModeHeading = "CSS Mode";
export const JavaModeHeading = "Java Mode";
export const MdeEditorExample = "MDE Editor Example";
export const MdeEditorText = `Enter text in the area on the left. For more info, click the ? (help) icon in the menu.`;
export const Instructions = "Instructions";
export const MNDeditortext =
  "Enter text in the area on the left. For more info, click the ? (help) icon in the menu.";
export const Profit = "Profit";
export const Delete = "Delete";
export const BasicDemo = "Basic Demo";
export const BootstrapBasicTables = "Bootstrap Basic Tables";

export const JobDescriptionHeading = "Job Description";
export const UIDesigner = "UI Designer";
export const EndlessTelecom = "Endless Telecom & Technologies , NY ";
export const Fulltime = "Full-time";
export const Contract = "Contract";
export const Parttime = "Part-time";
export const Internship = "Internship";
export const Temporary = "Temporary";
export const Commission = "Commission";

export const PersonalDetails = "Personal Details";
export const RepeatPassword = "Repeat Password";
export const BirthDate = "Birth Date";
export const CollegeName = "College Name";
export const Period = "Period";
export const DegreeLevel = "Degree Level";
export const Specialization = "Specialization";
export const YourExperience = "Your Experience";
export const YourEducation = "Your Education";
export const UploadCoverLetter = "Upload Cover Letter";
export const UploadYourCV = "Upload Your CV";
export const UploadRecommendations = "Upload Recommendations";
export const UploadYourFiles = "Upload Your Files";

export const JobDetaildec =
  "Xolo is looking for a UI/UX Designer to join our team. The world is seeing an explosion in the amount and variety of location-baWe are looking for a versatile UX/UI Designer to join our growing design team. Our designers contribute to clients’ projects at all stages of development. We might start from scratch, conducting user and stakeholder interviews, making personas and journey maps, and continue on to iterating on designs and prototypes through delivering final assets for launch. We might come into the middle of an in-flight program-size project and conduct analysis and usability correction or feature enhancement. We might provide research and vision for handoff to an internal development team.";

export const ImageGallery = "IMAGE GALLERY";
export const GalleryGridWithDescription = "Gallery Grid With Description";
export const Imagedesc =
  "is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.";
export const MasonryGallery = "MASONRY GALLERY";
export const LearningCardsDetails =
  "Java is an object-oriented programming language. Sun Microsystems first released Java in the year 1995. It is popularly used for developing Java applications in data centers, laptops, cell phones, game consoles, and scientific supercomputers. There are multiple websites and applications which will not work if Java is not installed.";
export const UpcomingCoursesHeading = "Upcoming Courses";
export const Loremipsum = "Lorem ipsum";
export const DetailedCourseParagraph1 = `Knowledge can be defined as awareness of facts or as practical skills, and may also refer to familiarity with objects or situations. Knowledge of facts, also called propositional knowledge, is often defined as true belief that is distinct from opinion or guesswork by virtue of justification. While there is wide agreement among philosophers that it is a form of true belief, many controversies in philosophy focus on justification: whether it is needed at all, how to understand it, and whether something else besides it is needed.`;
export const DetailedCourseParagraph2 = `Knowledge can be produced in many different ways. The most important source is perception, which refers to the usage of the five senses. Many theorists also include introspection as a source of knowledge, not of external physical objects, but of one's own mental states. Other sources often discussed include memory, rational intuition, inference, and testimony. According to foundationalism, some of these sources are basic in the sense that they can justify beliefs without depending on other mental states. This claim is rejected by coherentists.`;
export const DetailedCourseHeading = `Knowledge can be defined as awareness of facts or as practical skills. there is wide agreement among philosophers that it is a form of true belief.`;
export const ChatStatus = "Status...";
export const STATUS = "STATUS";
export const CallParagraph =
  "Established fact that a reader will be distracted";
export const CallParagraph2 = "Dolore magna aliqua";
export const Fax = "Fax";

export const CreativeUnitedStates = "Creative - United States";
export const JobDescription = "Job Description";
export const Qualifications = "Qualifications";
export const qualifytext1 =
  "Have shipped multiple iOS, Android, and/or web products ";
export const qualifytext2 = "5+ years UI/UX experience";
export const qualifytext3 =
  "Portfolio demonstrating mastery of native iOS, Android, and/or responsive web design principles";
export const qualifytext4 =
  "Ability to autonomously pursue elegant solutions to open-ended problems";
export const qualifytext5 = "Comfort with ambiguity";
export const qualifytext6 = "ively work on more than one project at a time";
export const qualifytext7 =
  "Experience conducting user research and stakeholder interviews";
export const qualifytext8 =
  "Solid grasp of standard design tools, ex: Sketch, Omnigraffle, the Adobe Suite, Zeplin, etc.";
export const qualifytext9 = "Bonus Considerations ";
export const AgencyExperience = "Agency experience";
export const AgencyExptext1 = "Experience working with Agile development teams";
export const AgencyExptext2 = "Experience with RITE method usability testing";
export const AgencyExptext3 =
  "Experience in visual and motion design; ability to translate UX design into high quality visuals";
export const AgencyExptext4 = "Mastery of Sketch & InVision";
export const AgencyExptext5 =
  "Knowledge of mobile or front-end web programming";
export const Perks = "Perks";
export const Perkstext1 = "Competitive pay";
export const Perkstext2 =
  "Competitive medical, dental, and vision insurance plans";
export const Perkstext3 = "-proviCompanyded 401(k) plan";
export const Perkstext4 = "Paid vacation and sick time";
export const Perkstext5 = "Free snacks and beverages";
export const Savethisjob = " Save this job";
export const SimilarJobs = "Similar jobs";
export const SeniorUXDesigner = "Senior UX designer";
export const Imagedescription =
  "is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.";
export const MarkJecnoBlog =
  "People just dont do it anymore. We have to change that. Sometimes the simplest things are the most profound.";
export const MarkJecno = "Mark Jecno";

export const SearchImageTime = "25 July 2023";
export const SearchDesc =
  "Accusamus et iusto odio dignissimos ducimus qui blanditiis.";
export const Hits = "Hits";
export const Hits15 = "15 Hits";
export const BlogDate = "January 2023";
export const Blogdcs = "Dressing is a way of life.";
export const Blogpara =
  "A huge part of it is the incomparable beauty you can encounter every day.";
export const Bloggallaryimg = "Dressing is a way of life.";

export const FrontEndWebDeveloper = "Front end web developer";
export const GraphicDesigner = "Graphic designer";
export const DesignerCRM = "Designer, CRM";
export const UIDesigner_E_commerce = "UI designer E-commerce";
export const ReactandReact_Native_Developer = "React/React Native Developer";
export const UIandUX_IT_Frontend_Developer = "UI/UX IT Frontend Developer";
export const Frontenddesigner = "Front end designer";
export const PHPdeveloper = "PHP developer";
export const ReactDeveloper = "React Developer";

export const ComputerSoftware = "Computer Software";
export const ITEngineer = "IT Engineer";
export const Serviceindustry = "Service industry";
export const FinancialServices = "Financial Services";
export const htmlcss = "HTML,scss & sass";
export const Javascript = "Javascript";
export const Nodejs = "Node.js";
export const GulpPug = "Gulp & Pug";
export const Angularjs = "Angular.js";

export const FindJobs = "Find jobs";
export const NewYork = "New York";

export const SanFrancisco = "San Francisco";
export const Washington = "Washington";
export const Seattle = "Seattle";
export const Chicago = "Chicago";
export const AllLocations = "All Locations";
export const AllJobTitle = "All Job Title";
export const JobTitle = "Job Title";
export const Industry = "Industry";
export const AllIndustries = "All Industries";
export const SpecificSkills = "Specific skills";
export const AllSkills = "All Skills";
export const UIUxdesigner = "UI/Ux designer";

export const FindCourse = "Find Course";
export const Categories = "Categories";
export const Accounting = "Accounting";
export const Design = "Design";
export const Development = "Development";
export const Management = "Management";
export const Duration = "Duration";
export const AllCourses = "All Courses";
export const PaidCourses = "Paid Courses";
export const FreeCourses = "Free Courses";
export const Registration = "Registration";

export const Filter = "Filter";
export const UIDesign = "UI Design";
export const UXDesign = "UX Design";
export const InterfaceDesign = "Interface Design";
export const UserExperience = "User Experience";
export const FrontendDevelopment = "Frontend Development";
export const BackendDevelopment = "Backend Development";
export const UpcomingCourses = "Upcoming Courses";
export const UXDevelopment = "UX Development";
export const BusinessAnalyst = "Business Analyst";
export const WebDevelopment = "Web Development";
export const CourseBy = "Course By";
export const JavaLanguage = "Java Language";
export const share = "share";
export const TypeHeadOptions = ["Student", "Bachelor", "Master", "Associate"];
export const Positions = [
  "Web Designer",
  "Graphic Designer",
  "UI Designer",
  "UI/UX Designer",
];
export const CompanyName = "Company Name";
export const CubaText = "Cuba Telecom & Technologies , NY";
export const Months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
export const Days = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
];
export const Years = [
  "1985",
  "1986",
  "1987",
  "1988",
  "1989",
  "1990",
  "1991",
  "1992",
  "1993",
  "1994",
  "1995",
  "1996",
  "1997",
  "1998",
  "1999",
  "2000",
  "2001",
  "2002",
  "2003",
  "2004",
  "2005",
  "2006",
  "2007",
  "2008",
  "2009",
  "2010",
  "2011",
  "2012",
  "2013",
  "2014",
  "2015",
];

export const CubaUnitedStates = "Cuba - United States";
export const JobHeading = "Job";
export const Completed = "Completed";
export const Bloggallaryimgpara =
  "A huge part of it is the incomparable beauty you can encounter every day.People just do it anymore profound.";
export const byPaigeTurner = "by: Paige Turner";
export const byPeteyCruiser = "by: Petey Cruiser";
export const learningtext =
  "inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit.inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit.inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.";
export const learningdetailtext =
  "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.";
// Tabs
export const Hometxt = "Home";
export const FormControl = "FormControl";
export const ZipError = "Please provide a valid zip.";
export const cityError = "Please provide a valid city.";
export const ValidFeedBack = "Looks good!";
export const TermsAndConditions = "Agree to terms and conditions";
export const CheckThisCheckbox = "Check this checkbox";
export const InvalidFeedBack = "Example invalid feedback text";
export const ToggleThisRadio = "Toggle this radio";
export const OrToggleThisRadio = "Or toggle this other radio";
export const MoreInvalidFeedBack = "More example invalid feedback text";
export const SelectMenu = "Open this select menu";
export const InvalidFile = "Example invalid form file feedback";
export const One = "One";
export const Two = "Two";
export const Three = "Three";
export const FirstNameRequire = "First name is required";
export const Website = "Website";
export const WithoutDetailsBlog =
  "Accusamus et iusto odio dignissimos ducimus qui blanditiis.";
export const BlogBy = "by:";
export const BlogWithoutDetailHeading = "Dressing is a way of life.";
export const BlogWithDetailHeading =
  "A huge part of it is the incomparable beauty you can encounter every day.";
export const Mark = "Mark";
export const Jecno = "Jecno";
export const SingleBlogHeading =
  "Knowledge can be defined as awareness of facts or as practical skills. there is wide agreement among philosophers that it is a form of true belief.";
export const SingleBlogParagraph1 = `Knowledge can be defined as awareness of facts or as practical skills, and may also refer to familiarity with objects or situations. Knowledge of facts, also called propositional knowledge, is often defined as true belief that is distinct from opinion or guesswork by virtue of justification. While there is wide agreement among philosophers that it is a form of true belief, many controversies in philosophy focus on justification: whether it is needed at all, how to understand it, and whether something else besides it is needed.`;
export const SingleBlogParagraph2 = `Knowledge can be produced in many different ways. The most important source is perception, which refers to the usage of the five senses. Many theorists also include introspection as a source of knowledge, not of external physical objects, but of ones own mental states. Other sources often discussed include memory, rational intuition, inference, and testimony. According to foundationalism, some of these sources are basic in the sense that they can justify beliefs without depending on other mental states. This claim is rejected by coherentists.`;
export const Comment = "Comment";
export const SingleBlogParagraph = `There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.`;
export const BlogPostText = `Enter text in the area on the left. For more info, click the ? (help) icon in the menu.`;
export const FilterHeading = "Filter";
export const ApplyForThisJob = "Apply for this job";
export const LocationHeading = "Location";
export const IndustryHeading = "Industry";
export const blogwithoutDetails = ` People just don't do it anymore. We have to change that. Sometimes the simplest things are the most profound.`;
export const Discard = "Discard";
export const Title = "Title";
export const Content = "Content";
export const Audio = "Audio";
export const Image = "Image";
export const Video = "Video";
export const JolioMark = "Jolio Mark";
export const QuickQuestions = "Quick Questions are answered";
export const SearchArticles = "SearchArticles";
export const LatestUpdates = "Latest Updates";
export const SeeAll = "See All";

// Faq anf knowledgebase
export const Articles = "Articles";
export const Knowledgebase = "Knowledgebase";
export const IntellectualProperty = "Intellectual Property";
export const SellingAndBuying = "Selling And Buying";
export const UserAccounts = "User Accounts";
export const Navigation = "Navigation";
export const WhychooseKnowledge = "Why Choose Knowledge Course ?";
export const DavidLinner = "David Linner";
export const UserChristopher = "User Christopher";
export const AskQuestion = "Ask Question";
export const Tutorials = "Tutorials";
export const HelpCenter = "Help center";
export const VideoTutorials = "Video Tutorials";
export const AskOurCommunity = "Ask our community";
export const VictoriaWilson = "Victoria Wilson";
export const FeaturedTutorials = "Featured Tutorials";
export const BrowseArticles = "Browse Articles";
export const HowCanIhelpyou = "How Can I help you?";
export const knowledgearticl = "knowledge articles by category";
export const KnowledgeCategories = "Knowledge Categories";
export const Faqpara =
  "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.";
export const Latestarticles = "Latest articles and videos";
export const DropdownTitle = "Dropdown";
export const Loss = "Loss";
export const SupportTicketList = "Support Ticket List";
export const ListOfTicketOpendByCustomers = "List of ticket opend by customers";
export const DeleteData = "Delete Selected Data..!";
export const Images = "Images";
export const Videos = "Videos";
export const All = "All";
export const Maps = "Maps";

export const TotalSaleHeading: string = "Total Sale";
export const CompareLastMonth: string = "Compare to last month";
export const PlaceHolderName: string = "Placeholder Name";
export const NumberingWizardHeading: string = "Numbering wizard";
export const Congratulations: string = "Congratulations ";
export const CongratulationsMessage: string =
  "Well done! You have successfully completed. ";
export const AboveInformationCorrect: string =
  "All the above information is correct";
export const ConfirmPassword: string = "Confirm Password";
export const AgreeToTermsAndConditions: string =
  "Agree to terms and conditions";
export const Expiration: string = "Expiration(MM/YY)";
export const CVVNumber: string = "CVV Number";
export const UploadDocumentation: string = "Upload Documentation";
export const LinkedIn: string = "LinkedIn";
export const Github: string = "Git hub";
export const SelectState: string = "Select State";
export const GiveFeedback: string = "Give Feedback";
export const StudentValidationFormHeading: string = "Student validation form";
export const Product: string = "Product";
export const ProductDetail: string = "Product Detail";
export const CurrentCartHeading: string = "Current Cart";
export const verticalValidationWizardHeading: string =
  "Vertical validation wizard";
export const AddProfile: string = "Add Profile";
export const ShippingFormHeading: string = "Shipping form";
export const BillingInformation: string = "Billing Information ";
export const OrderID: string = "Order ID";
export const FillFollowingInformation: string =
  "Fill up the following information ";
export const OrderConfirmed: string = "Thank you! Your order is confirmed.";
export const OrderConfirmedDetails: string =
  "An email with your orders specifics will be sent to you as order confirmation.";
export const TypeAheadHeading: string = "Typeahead";
export const SelectAccountDescription: string =
  "It has long been known that distracting information on a page will lose a readers attention.";
export const TwoFactorAuthenticationHeading: string =
  "Two-factor authentication";
export const TwoFactorAuthenticationDetails: string =
  "Click on the authentication button below and scan the QR code";
export const DefaultCalendarHeading: string = "Default calendar";
export const ReactstrapCalendarHeading: string = "Reactstrap calendar";
export const Month: string = "Month";
export const Week: string = "Week";
export const Time: string = "Time";
export const DefaultTouchSpinHeading: string = "Default Touchspin";
export const OutLinedTouchSpinHeading: string = "Outlined Touchspin";
export const RoundedTouchSpinHeading: string = "Rounded Touchspin";
export const IconsWithPrefixAndPostFixHeading: string =
  "Icons with prefix and postfix";
export const ButtonsWithPrefixAndPostFixHeading: string =
  "Buttons with prefix and postfix";
export const Pre: string = "Pre";
export const Post: string = "Post";
export const CustomSwitchHeading: string = "Custom switch";
export const IconsWithHeading: string = "Icons switch";
export const UncheckedSwitchHeading: string = "Unchecked switch";
export const bordersWithIconsHeading: string = "Borders With Icons";
export const DisabledOutlineSwitchHeading: string = "Disabled outline switch";
export const VariationOfSwitchesHeading: string = "Variation of switches";
export const Skewed: string = " Skewed";
export const Flip: string = "Flip";
export const SwitchWithIconsHeading: string = "Switch With Icons";
export const SwitchSizingHeading: string = "Switch Sizing";
export const ClipboardOnParagraphHeading: string = "Clipboard on paragraph";
export const CopyFromParagraph: string = "Copy from paragraph";
export const ClipboardOnParagraphValue: string =
  "On that day, hopes and dreams were crushed. Even though it should have been anticipated, it nonetheless surprised me. The warning indicators have been disregarded in favour of the slim chance that it would actually occur. From a hopeful prospect, it had evolved into an unquestionable conviction that it must be fate. That was up until it wasn't, at which point all of the aspirations and dreams collapsed.";
export const ClipboardOnTextAreaValue: string =
  "A web designer must always enhance their work since creating websites is a creative effort. Therefore, a web designer must be more imaginative to produce exceptional results. Blogs about web design assist web designers in learning about new technologies, offer lessons, news, direction for a freebie, and much more. These blogs allow web designers to stay creative and improve their abilities. Therefore, advice from web design blogs is required to improve your business.";
export const Copy: string = "Copy";
export const ClipBoardOnTextInputHeading: string = "Clipboard on text input";
export const Cut: string = "Cut";
export const ClipBoardOnTextArea: string = "Clipboard on textarea";
export const CutCopyFromTextArea: string = "Cut/copy from textarea";
export const CutCopyFromInputArea: string = "Cut/copy from text input";
export const CopyParagraph: string = "Copy portion from paragraph";
export const copyText: string =
  "Web design is the process of creating websites ";
export const copyTextParagraph: string =
  "that are visible online. Take a website design course to learn how to  create an appealing and responsive website. In the discipline of web design, there are degree, diploma, postgraduate degree, and certificate programmes. A web designer is responsible for a website's look, feel, and occasionally even content.";
export const BasicTypeAheadHeading: string = "Basic typeahead";
export const BloodHoundHeading: string = "Blood Hound";
export const CustomTemplate: string = "Custom templates";
export const MultipleSectionWithHeader: string =
  "Multiple sections with headers";
export const RemotetypeAheadHeading: string = "Remote typeahead";
export const PreFetchHeading: string = "Prefetch";

//  tables
export const BasicTable = "Basic Table";
export const InverseTable = "Inverse Table";
export const InverseTablePrimaryBackground =
  "Inverse Table with Primary background";
export const HoverableRows = "Hoverable rows";
export const TextBackgroundUtilities = "Text or background utilities";
export const TableHeadOptions = "Table Head Options";
export const TableHeadspan =
  "Similar to tables and dark tables, use the modifier classes";
export const theadlight = ".thead-light";
export const tomake = "to make";
export const thead = "thead ";
export const theadtext = "appear light or dark gray.";
export const StripedRow = "Striped Row";
export const StripedRowInverseTable = "Striped Row with Inverse Table";
export const Caption = "Caption";
export const ResponsiveTables = "Responsive Tables With Hover and Stripped";
export const BreckPointSpecific = "Breakpoint Specific";

export const ExtraLargeTables = "Extra Large Tables";
export const LargeTable = "Large Table";
export const DefaultTable = "Default Table";
export const SmallTable = "Small table";
export const ExtraSmallTable = "Extra Small table";
export const HorizontalBorders = "Horizontal Borders";
export const VerticalBorders = "Vertical Borders";
export const BothBordeds = "Both Bordeds";
export const BorderlessTable = "Borderless Table";
export const DefaultTableBorder = "Default Table Border";
export const SolidBorder = "Solid Border";
export const DoubleBorder = "Double Border";
export const DottedBorder = "Dotted Border";
export const DashedBorder = "Dashed Border";
export const DessertType = "Dessert Type";
export const Fat = "Fat";
export const Dessert = "Dessert";
export const Weigth = "Weigth";
export const BorderBottomColor = "Border Bottom Color";
export const DefultStyling = "Defult Styling";
export const TableFooterStyling = "Table Footer Styling";
export const TableHeadOptionsPrimaryBackground =
  "Table head options With Primary Background";
export const CustomTableColor = "Custom Table Color";
export const CustomTableColorHoverStripped =
  "Custom Table Color with Hover and Stripped";
export const Designation = "Designation";
export const Company = "Company";
export const Language = "Language";
export const Country = "Country";
export const Id = "Id";
export const JoinDate = "Join Date";
// export const  LastName= 'Last Name';
export const Office = "Office";
export const Age = "Age";
// export const  FirstName = 'First Name';
export const Position = "Position";
export const Salary = "Salary";
export const Schedule = "Schedule";
export const Security = "Security";
export const Status = "Status";
export const TeamLead = "Team Lead";
export const SignalName = "Signal Name";
export const Stage = "Stage";
export const Role = "Role";
export const CreditVolume = "Credit Volume";
export const Sex = "Sex";
export const EmployeeName = "Employee Name";
export const Experience = "Experience";
export const ContactNo = "ContactNo";
export const Calories = "Calories";
export const Price = "Price";
export const Quantity = "Quantity";
// export const   Total = 'Total';
export const Name = "Name";
export const OrderId = "OrderId";
export const Assign = "Assign";
export const Phone = "Phone";
export const Hours = "Hours";
export const Performance = "Performance";
export const DomesticGross = "Domestic Gross";
export const FilmTitle = "Film Title";
export const Released = "Released";
export const Studio = "Studio";
export const Spots = "Spots";
export const Trainer = "Trainer";
export const Type = "Type";
export const classname = "classname";
export const TableComponents = "Table Components";
export const ReactstrapTables = "Reactstrap Tables";
export const UIComponents = "UI Components";
export const Alerts = "Alerts";
export const ButtonAddonsHeading: string = "Button Addons";
export const Submit: string = "Submit";
export const CustomFormsHeading: string = "Custom forms";
export const Options: string = "Options";
export const SelectYourFavoritePixelstrapTheme: string =
  "Select Your Favorite Pixelstrap theme";
export const SelectYourFavoriteColors: string = "Select Your Favorite Colors";
export const SelectYourFavoriteChocolates: string =
  "Select Your Favorite Chocolates";
export const SelectYourFavoriteTheme: string = "Select Your Favorite Theme";
export const Tivo: string = "Tivo";
export const Cuba: string = "Cuba";
export const Roxo: string = "Roxo";
export const Yellow: string = "Yellow";
export const Red: string = "Red";
export const Orange: string = "Orange";
export const DarkChocolates: string = "Dark Chocolates";
export const DairyMilk: string = "Dairy Milk";
export const Kitkat: string = "Kitkat";
export const Oslo: string = "Oslo";
export const Koho: string = "Koho";
export const Voxo: string = "Voxo";
export const CustomFileInputHeading: string = "Custom file input";
export const ButtonsWithDropDownsHeading: string = "Buttons With Drop Downs";
export const SegmentedButtonsHeading: string = "Segmented buttons";
export const MultipleInputsHeading: string = "Multiple inputs";
export const Upload: string = "Upload";
export const Verify: string = "Verify";
export const DropdownHeading: string = "Dropdown";
export const CheckboxesAndRadiosHeading: string = "Checkboxes and radios";
export const Info: string = "Info";
export const Secondary: string = "Secondary";
export const SizingHeader: string = "Sizing";
export const Small: string = "Small";
export const Large: string = "Large";
export const FirstAndLastName: string = "First and last name";
export const DollarSign: string = "$";
export const ZeroAmount: string = "0.00";
export const BasicInputGroupsHeading: string = "Basic input groups";
export const VariationOfAddonsHeading: string = "Variation of addons";
export const RecipientUserName: string = "@example.com";
export const BasicHeader: string = "Basic";
export const WithTextArea: string = "With textarea";
export const WrappingHeading: string = "Wrapping";
export const WrappingDetails: string = `Input groups wrap by default via flex-wrap: wrap in order to accommodate custom form field validation within an input group. You may disable this with <code>.flex-nowrap</code>.`;
export const LeftAddon: string = `Left Addon`;
export const RightAddon: string = `Right Addon`;
export const JointAddon: string = `Joint Addon`;
export const LeftAndRightAddon: string = `Left & Right Addon`;
export const SolidStyle: string = `Solid style`;
export const FlatStyle: string = `Flat style`;
export const RaiseStyle: string = `Raise style`;
export const DefaultStyleHeading: string = `Default Style`;
export const EdgeButtons: string = `Edge Buttons`;
export const RaisedButtons: string = `Raised Buttons`;
export const FlatStyleHeading: string = `Flat Style`;
export const INR: string = `INR`;
export const InputMasks: string = `Input masks`;
export const VariationRadioHeading: string = `Variation radio`;
export const SelectYourPaymentMethod: string = "Select your payment method";
export const MostImportantThingsToLearnAboutWebDesign: string =
  "What are the most important things to learn about web design?";
export const RadiosWithCreativeOptionsSVGIcons: string =
  "Radios With Creative Options & SVG Icons";
export const WhichActivitiesDoYouEnjoy: string =
  "Which of the following activities do you enjoy doing in your free time?";
export const VariationCheckBoxHeading: string = "Variation checkbox ";
export const ItIsTimeTo: string = "It's time to";
export const upgrade: string = "upgrade";
export const BestSuitsYourRequirements: string =
  " Select the theme that best suits your requirements, and you're ready to go!";
export const Sales: string = " Sales";
export const Estimated: string = " Estimated";
export const DayShipping: string =
  "Day Shipping ( Duties end tax may be due delivery )";
export const WithoutBordersStyleHeading: string = "Without borders style";
export const SolidBorderStyleHeading: string = "Solid border style";
export const offerStyleBorderHeading: string = "Offer style border";
export const InlineStyleHeading: string = "Inline style";
export const VerticalStyleHeading: string = "vertical style";
export const DeliveryOptionHeading: string = "Delivery Option";
export const BuyingOptionHeading: string = "Buying Option";
export const StartRatingHeading: string = "start rating";
export const HorizontalStyleHeading: string = "Horizontal style";
export const DeliveryOption: string = "Horizontal style";
export const BuyingOption: string = "Buying Option";
export const DateFormatHeading: string = "Date Format";
export const Date: string = "Date";
export const DateFormatType: string = "Date format type";
export const TimeFormatHeading: string = "Time Format";
export const TimeFormatType: string = "Time format type";
export const HourMonthType: string = "Hour/month type";
export const DefaultInputMask: string = "Default Input Mask";
export const Currency: string = "Currency";
export const Prefix: string = "Prefix";
export const Delimiter: string = "Delimiter";
export const PhoneNumber: string = "Phone Number";
export const CardNumber: string = "Card Number";
export const Tailprefix: string = "Tail prefix";
export const TooltipFormValidationHeading: string = "Tooltip Form Validation";
export const LastName: string = "Last name";
export const SubmitForm: string = "Submit form";
export const stateError: string = "Please select a valid state.";
export const CityError: string = "Please provide a valid city.";
export const Zip: string = "Zip";
export const State: string = "State";
export const City: string = "City";
export const UserName: string = "Username";
export const UserNameError: string =
  "Please choose a unique and valid username.";
export const BrowserDefaultsHeading: string = "Browser defaults";
export const EmailAddress: string = "Username / NIP";
export const ChooseFile: string = "Choose file";
// export const SelectYourPaymentMethod: string = "Select your payment method";
export const Visa: string = "Visa";
export const MasterCard: string = "MasterCard";
export const PayPal: string = "Paypal";
export const AgreePolicies: string = "I agree to the policies";
export const InformationConfirm: string =
  "Are you sure above information are true";
// export const Submit: string = "Submit";
export const NameError: string = "Please enter your valid Name";
export const PasswordError: string = "Please enter your valid password";
export const StateError: string = "Please select a valid state.";
export const MaterCard: string = "MaterCard";
export const FavoritePixelStrapTheme: string =
  "Select Your Favorite Pixelstrap theme";
export const InvalidSelectFeedBack: string = "Invalid select feedback";
export const InvalidFormFileSelected: string = "Invalid form file selected";
export const InvalidMessageError: string =
  "Please enter a message in the textarea.";
export const AgreeConditions: string = "Agree to terms and conditions";
export const AgreeFeedback: string = "You must agree before submitting.";
// export const Cuba: string = "Cuba";
// export const Tivo: string = "Tivo";
export const Wingo: string = "Wingo";
export const UK: string = "U.K ";
export const India: string = "India ";
export const Thailand: string = "Thailand";
export const Newyork: string = "Newyork";
export const BasicFormHeading: string = "Basic form";
export const FloatingFormHeading: string = "Floating Form";
export const SelectSizingHeading: string = "Select Sizing";
export const CheckMeOut: string = "Check me out";
export const SignIn: string = "Login";
export const YourHobbies: string = "What's Your Hobbies ";
export const KhoKho: string = "Kho-kho";
export const ReadingBooks: string = "Reading Books";
export const Creativity: string = "Creativity";
export const FormControlSizingHeading: string = "Form Control Sizing";
export const BasicHTMLInputControlHeading: string = "Basic HTML Input Control";
export const BasicFloatingInputControlHeading: string =
  "Basic floating input control";
export const FileInputHeading: string = "File Input";
export const DefaultExample: string = "Default file input example";
export const MultipleExample: string = "Multiple files input example";
export const DisabledExample: string = "Disabled file input example";
export const SmallFileInputExample: string = "Small file input example";
export const LargeFileInputExample: string = "Large file input example";
export const FlatInputStyleHeading: string = "Flat Input Style";
export const MultiplePaintingsItems: string[] = [
  "Landscape",
  "Portrait ",
  "Oil Painting",
  "Abstract art",
  "Acrylic",
];
export const MultiplePaintingsLabel: string = "Select your multiple paintings";
export const PleaseDoComments: string = "Please do comments";
export const PlaceHolderHeading: string = "Placeholder ";
export const ColorPickerHeading: string = "Color picker";
export const DataListExampleHeading: string = "Datalist example";
export const countryList = [
  "San Francisco",
  "New York",
  "Seattle",
  "Los Angeles",
  "Chicago",
  "India",
];
export const DateHeading: string = "Date";
export const DateAndTimeHeading: string = "Date and time";
export const CommentsHeading: string = "Comments";
export const URLHeading: string = "URL";
export const MaximumLengthHeading: string = "Maximum Length";
export const MonthHeading: string = "Month";
export const NumberHeading: string = "Number";
export const PasswordHeading: string = "Password";
export const StaticTextHeading: string = "Static Text";
export const StaticTextContent: string = "Hello !... This is my magical text";
export const TelephoneHeading: string = "Telephone";
export const TimeHeading: string = "Time";
export const OpenThisSelectMenu: string = "Open This Select Menu";
export const WeekHeading: string = "Week";
export const LayoutHeading: string = "Layout";
export const EmailHeading: string = "Email";
export const InputGroupHeading: string = "Input group";
export const WorksWithSelects: string = "Works with selects";
export const InvalidInputHeading: string = "Invalid input";
export const ValidInputHeading: string = "Valid Input";
export const InputWithValue: string = "Input With Value";
export const EdgesInputStyleHeading: string = "Edges Input Style";
export const FileInputExample: string = "Default file input example";
export const DefaultInput: string = "Default Input";
export const Male: string = "Male";
export const Female: string = "Female";
export const Comments: string = "Comments";
export const RaiseInputStyleHeading: string = "Raise Input Style";
export const SelectTheColorHeading: string = "Select the color you like below";
export const ColorList: string[] = [
  "Red",
  "Yellow",
  "Orange",
  "White",
  "Black",
  "Gray ",
  "Brown",
  "Purple ",
  "White",
];
export const DefaultCheckBoxHeading: string = "Default CheckBox";
export const DefaultChecksHeading: string = "Default Checks";
export const DefaultCheckBox: string = "Default checkbox";
export const CheckedCheckBox: string = "Checked checkbox";
export const DisabledChecksHeading: string = "Disabled Checks";
export const DisabledCheckBox: string = "Disabled checkbox";
export const InlineInputTypesHeading: string = "Inline input-types";
export const InlineCheckBoxHeading: string = "Inline Checkbox";
export const InlineRadiosBoxHeading: string = "Inline Radios";
export const InlineSwitchesHeading: string = "Inline Switches";
export const AnimatedButtonsHeading: string = "Animated buttons";
export const SelectPaymentMethod: string = "Select your payment method";
export const YourFavoriteSocialMedia: string =
  "What is your favorite social media? ";
export const BasicRadioAndCheckBox: string = "Basic radio and checkbox";
export const SimpleCheckBox: string = "Simple Checkbox";
export const SimpleRadiosHeading: string = "Simple Radios";
export const RadioToggleButtonsHeading: string = "Radio toggle buttons";
export const OutlinedCheckBoxStylesHeading: string = "Outlined checkbox styles";
export const RightSwitchesHeading: string = "Right Switches";
export const PaymentMethod: string = "Payment Method";
export const Item: string = "Item";
export const Subtotal: string = "Subtotal";
export const Fees: string = "Fees";
export const Total: string = "Total";
export const SelectCustomer: string = "Select Customer";
export const OrderDetailsHeader: string = "Order Details";
export const PlaceOrder: string = "Place Order";
export const OurProductHeader: string = "Our Product";
export const OurProductDetail: string =
  "Browse & Discover Thousands of products here!";
export const OurProductDetailDropDown: string[] = [
  "Mac-book",
  "Headphones",
  "HD TV",
];
export const SelectCategory: string = "Select Category";
export const ShopByCategories: string = "Shop by Categories";
export const ViewAll: string = "View All";
export const Buttons: string = "Buttons";
export const DefaultButtonsHeading: string = "Default Buttons";
export const LargeButtonsHeading: string = "Large Buttons";
export const SmallButtonsHeading: string = "Small Buttons";
export const ExtraSmallButtonsHeading: string = "Extra Small Buttons";
export const ActiveButtonsHeading: string = "Active Buttons";
export const DisabledButtonsHeading: string = "Disabled Buttons";
export const CustomStateButtonsHeading: string = "Custom State Buttons";
export const OutlineButtonsHeading: string = "Outline Buttons";
export const BoldBorderOutlineButtonsHeading: string =
  "Bold Border Outline Buttons";
export const OutlineLargeButtonsHeading: string = "Outline Large Buttons";
export const OutlineSmallButtonsHeading: string = "Outline Small Buttons";
export const OutlineExtraSmallButtonsHeading: string =
  "Outline Extra Small Buttons";
export const DisabledOutlineButtonsHeading: string = "Disabled Outline Buttons";
export const GradientButtonsHeading: string = "Gradient Buttons";
export const ButtonGroupHeading: string = "Button Group";
export const Option1: string = "Option 1";
export const Option2: string = "Option 2";
export const RadioButtonGroup: string = "Radio button group";
export const BasicButtonGroup: string = "Basic button group";
export const EdgesButtonGroup: string = "Edges button group";
export const FlatButtonGroup: string = "Flat button group";
export const LargeButtonGroup: string = "large Button group";
export const LargeEdgesButtonGroup: string = "large Edges Button group";
export const OutlineCustomButtonGroup: string = "Outline Custom button group";
export const OutlineButtonGroup: string = "Outline button group";
export const OutlineEdgesButton: string = "Outline Edges button";
export const OutlineFlatButton: string = "Outline flat button";
export const CheckBoxButtonGroup: string = "Check Box button group";
export const Action: string = "Action";
export const AnotherAction: string = "Another Action";
export const Header: string = "Header";
export const Nesting: string = "Nesting";
export const Vertical: string = "Vertical";
export const Button: string = "Button";
export const ButtonDropdown: string = "ButtonDropdown";
export const DefaultDate: string = "Default Date";
export const HumanFriendly: string = "Human Friendly";
export const MinMaxValue: string = "Min-Max Value";
export const DisabledDates: string = "Disabled Dates";
export const MultiplesDatesHeading: string = "Multiples Dates";
export const Range: string = "Range";
export const PreloadingDates: string = "Preloading Dates";
export const hourPicker: string = "24-hour Time Picker";
export const TimePickerLimits: string = "Time Picker W/Limits";
export const PreloadingTime: string = "Preloading Time";
export const TimePickerRange: string = "TimePicker with Limited Time Range";
export const TimePickerMinMaxRange: string =
  "TimePicker with Min/Max Time Range";
export const DateWithTime: string = "Date With Time";
export const ProgressBarHeading: string = "Progress Bar";
export const Checkbox: string = "Checkbox";
export const RadioButtons: string = "Radio Buttons";
export const Select: string = "Select";
export const Input: string = "Input";
export const TooltipTriggers: string = "Tooltip Triggers";
export const Switch: string = "Switch";
export const Badges: string = "Badges";
export const Add: string = "Add";
export const CreatePlus: string = "Create +";
export const Customer: string = "Customer";
export const CreateCustomer: string = "Create Customer";
export const MobileNumber: string = "Mobile Number";
export const EmptyCartDetails: string = "Empty Cart Details";
export const Category: string = "Category";
export const BasicTableWithBorderBottomColor: string =
  "Basic Table With Border Bottom Color";
export const BasicTableWithBorderBottomColorSpan: string = `Use a class<code>table</code> to any table, and <code>.border-bottom-*</code>class for Border bottom color`;
export const InverseTableSpan: string = `Use a class <code>table-inverse</code> inside table element.`;
export const HoverableRowsWithHorizontalBorderSpan: string = `Hoverable row use a class  <code>table-hover</code> and for Horizontal border use a class <code>.table-border-horizontal</code> , Solid border Use a class<code>.border-solid .table</code>class.`;
export const InverseTablePrimaryBackgroundSpan: string = `Use a class <code>.bg-info, .bg-success, .bg-warning and .bg-danger classes.</code> with light text on dark backgrounds inside table element.<br>To set the light background color use .bg-[color] class where [color] is the value of your selected color from stack color palette. So for teal color background class will be .bg-teal`;
export const HoverableRowsWithHorizontalBorder: string = `Hoverable Rows With Horizontal Border`;
export const CaptionSpan: string = `A <caption> functions like a heading for a table. It helps users with screen readers to find a table and understand what it’s about and decide if they want to read it.`;
export const TableHeadOptionsSpan: string = `Similar to tables , use the modifier classes<code>.table-[color]</code>  to make <code>thead</code>appear in any color.`;
export const StripedRowWithInverseTable: string = `Striped Row with Inverse Table`;
export const StripedRowWithInverseTableSpan: string = `Use <code>.table-striped</code> to add zebra-striping to any table row within the <code></code>. This styling doesn't work in IE8 and below as :nth-child CSS selector isn't supported.`;
export const BreckPointSpecificSpan: string = `Use  <code>.table-responsive"❴-sm|-md|-lg|-xl|-xxl❵"</code> functions like a heading for a table. It helps users with screen readers to find a table and understand what it’s about and decide if they want to read it.`;
export const ResponsiveTablesSpan: string = `A <code>.table-responsive ,.light-card</code> inside table element.`;
export const sizeTableSpan: string = `Example of Extra large table, Add<code>.table-xl</code> class to the<code>.table</code> , Large table Add <code> .table-lg</code>  , Default table Add <code>.table-de</code>  , Small table Add <code>.table-sm </code>, Extra Small table Add <code>.table-xs</code>to create a table.`;
export const sizeTable: string = `sizing Table`;
export const CustomTable: string = `Custom Table Color With Hover And Stripped`;
export const CustomTableSpan: string = `Use class <code>table-hover, table-striped table-*table-info,table-success,table-success,table-info,table-danger,table-primary,table-secondary,table-light,table-active</code>  inside table element.`;
export const DashedBorderSpan: string = `Dashed border use class <code>.table-dashed</code> , for Dotted border use class<code>.table-dotted</code>, for Double border use class<code>.table-Double</code>`;
export const className: string = "Classname";
export const DefaultButton: string = "Default Button";
export const ApexChartHeading: string = "Apex Chart";
export const GoogleChartHeading: string = "Google Chart";
export const ChartJsHeading: string = "ChartJs Chart";

// charts
export const BasicAreaChart: string = "Basic Area Chart";
export const AreaSpalineChart: string = "Area Spaline Chart";
export const BarChart: string = "Bar chart";
export const ColumnChart: string = "Column Chart";
export const BubbleChart: string = "3d Bubble Chart";
export const SteplineChart: string = "Stepline Chart";
export const PieChart: string = "Pie Chart ";
export const DonutChart: string = "Donut Chart";
export const MixedChart: string = "Mixed Chart";
export const CandlestickChart: string = "Candlestick Chart";
export const RadarChart: string = "Radar Graph";
export const RadialBarChart: string = "Radial Bar Chart";
export const AreaChart: string = "Area Chart";
export const BarChart2: string = "bar-chart2";
export const BasicBarChart: string = "Basic bar Chart";
export const ComboChart: string = "ComboChart";
export const GanttChart: string = "Gantt Chart";
export const LineChart: string = "Line Chart";
export const MaterialDesign: string = "Material Design";
export const SliceVisibilityThreshold: string = "Slice Visibility Threshold";
export const StackingAreaChart: string = "Area Chart 2";
export const RotatingPieChart: string = "Rotating A Pie Chart";
export const LineChart2: string = "Line Chart-2 Chart";
export const DoughnutChart: string = "Doughnut Chart";
export const PolarChart: string = "Polar Chart";
export const BackToHomePage: string = "BACK TO HOME PAGE";
export const WeAreComingSoon: string = "WE ARE COMING SOON";
export const SampleCard: string = "Sample Card";
export const CurrentLocation: string = "Current Location";
export const MarkerMap: string = "Marker Map";
export const Polygons: string = "POLYGONS";
export const Polylines: string = "Polyline";
export const GeoJsonMapDemo: string = "GeoJsonMap Demo";
export const AnimateMap: string = "Animate Map";
export const AnimatePanning: string = "Animate panning";
export const SetMarkerWithPopup: string = "Set Marker with Popup";
export const VerificationCodeHeading: string = "Verification code";
export const FactorAuthentication: string = "2 factor authentication";
export const qrCodeAlertText: string =
  " If your qr code is not working then enter this code in your input field.";
export const QrCodeText: string =
  "Scan the QR code using an authenticator app and website such as abc authenticator, OTP xyz, or pqr authenticator. You must input the six-digit code it generates below.";
export const EmailVerificationHeading: string = "Email verification";
export const modalText: string =
  "To log into your account, youll also need to enter your username, password, and a code that was sent to you through SMS or an app.";
export const EmailVerificationText: string =
  " A verification code has been sent to your email. This code will be valid for 15 minutes.";
export const Information: string = "Information";
export const PaypalOption: string =
  "You will be taken to the paypal website to finish your transaction safely";
export const CreditCardText: string =
  "Transferring money securely through your bank account. Mastercard, Visa, Discover, and Stripe are all accepted";
export const CreditCard: string = "Credit Card";
export const CashOnDeliveryHeading: string = "Cash On Delivery";
export const CashOnDeliveryText: string =
  "After your order is delivered, make a cash payment";
export const PaymentInformation: string = "Payment Information";
export const PaymentInformationText: string =
  "Fill up the following information to send you the order";
export const ProceedNext: string = "Proceed to Next";
export const ShippingMethod: string = "Shipping Method";
export const ShippingInformation: string = "Shipping Information";
export const SavedAddress: string = "Saved Address";
export const ShippingInformationText: string =
  " Fill up the following information to send you the order";
export const PortfolioURL: string = " Portfolio URL";
export const ProjectDescription: string = " Project Description";
export const SocialLinks: string = " Social Links ";
export const Twitter: string = " Twitter";
export const Previous: string = " Previous";
export const Next: string = " Next";
export const NetBanking: string = " NET BANKING";
export const SelectYourBank: string = " SELECT YOUR BANK";
export const Finish: string = "Finish";
export const OtpCode: string = "Your OTP Code here:";
export const OtpCodeSent: string = "We've sent a verification code to";
export const NotReceivedCode: string = "Not received your code?";
export const Call: string = "Call";
export const Resend: string = "Resend";
export const OR: string = "OR";
export const AccountName: string = "Account Name";
export const projects: string = "projects";
export const projectDescription: string = "project and write a description";
export const SelectTeamWith: string = "Select team size with ";
export const Continue: string = "Continue";
export const ContactDetails: string = "Contact details";
export const OrganizationName: string = "Organization Name";
export const JoinOrganizationType: string = "Join organization type";
export const OrganizationDescription: string = "Organization description";
export const ContactDetail: string =
  " Please visit the documentation page if you require further information.";
export const TeamDetails: string =
  " Agile teams are cross-functional and made up of 5-11 on a regular basis team member.";
export const listOfYears: number[] = [
  2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034, 2035,
];
export const CardHolder: string = "Card Holder";
export const AccountType: string = "Select the type of account";
export const SearchYour: string = "Search your";
export const informationCheck: string = "information please check it";
export const AadhaarNumber: string = "Aadhaar Number";
export const PAN: string = "PAN";
export const ChooseBanks: string = "Choose from these popular banks";
export const ContactNumber: string = "Contact Number";
export const describeYourIssue: string = "If no, could you please describe?";
export const ZipCode: string = "Zip Code";
export const SuccessfullyCompleted: string = "Successfully Completed";
export const SelectBanks: string =
  "Select the option how you want to receive important notifications.";
export const CryptoAnnotationsHeading: string = "Crypto Annotations";
export const CryptocurrencyPricesHeading: string = "Cryptocurrency Prices";
export const FinanceHeading: string = "Finance";
export const LiveProductsHeading: string = "Live Products";
export const MonthlyHistoryHeading: string = "Monthly  History";
export const MonthlySalesHeading: string = "Monthly Sales";
export const OrderStatusHeading: string = "Order Status";
export const SkillStatusHeading: string = "Skill Status";
export const StockMarketHeading: string = "Stock Market";
export const TotalProductHeading: string = "Total Product";
export const TotalProjectHeading: string = "Total Project";
export const TurnOverHeading: string = "Turn over";
export const UsesHeading: string = "Uses";
export const CommonErrorPageText: string =
  " The page you are attempting to reach is currently not available.This may be because the page does not exist or has been moved.";
export const DoNotAccount: string = "Don't have account?";
export const CreateAccount: string = "Create Account";
export const FacebookHeading: string = "facebook";
export const TwitterHeading: string = "twitter";
export const linkedInHeading: string = "LinkedIn";
export const siswaInHeading: string = "Siswa";
export const pendampingInHeading: string = "Pendamping";
export const mahasiswaInHeading: string = "Mahasiswa";
export const SignInWith: string = "Daftar Akun";
export const ForgotPassword: string = "Forgot password?";
export const RememberPassword: string = "Remember password";
export const SignInAccount: string = "Sign in to IDO";
export const EnterSatuAccount: string = "Gunakan NIP dan Password SIDAK anda";
export const CreateYourAccount: string = "Create your account";
export const EnterEmailPasswordLogin: string =
  "Enter your email & password to login";
export const EnterYourPersonalDetails: string =
  "Enter your personal details to create account";
export const YourName: string = "Your Name";
export const PrivacyPolicy: string = "Privacy Policy";
export const AgreeWith: string = "Agree with";
export const SignUpWith: string = "Or signup with";
export const HaveAccount: string = "Already have an account?";
export const Unlock: string = "Unlock";
export const EnterYourPassword: string = "Enter your Password";
export const ResetYourPassword: string = "Reset Your Password";
export const EnterYourMobileNumber: string = "Enter Your Mobile Number";
export const Send: string = "Send";
export const IfDontReciveOtp: string = "If don't receive OTP?";
export const EnterOTP: string = "Enter OTP";
export const CreateYourPassword: string = "Create Your Password";
export const NewPassword: string = "New Password";
export const RetypePassword: string = "Retype Password";
export const Done: string = "Done";
export const havePassword: string = "Already have an password?";
export const CreateYourPassWord: string = "Create Your Password";

export const defaultButtonsHeadingData: string = "Bootstrap state buttons";
export const LargeButtonsHeadingData: string = `Add <code>.btn-lg</code> class for large size buttons`;
export const SmallButtonsHeadingData: string = `Add <code>.btn-sm</code> class for small size buttons`;
export const ExtraSmallButtonsHeadingData: string = `Add <code>.btn-xs</code> class for extra small size buttons`;
export const ActiveButtonsHeadingData: string = `Add <code>.active</code> class for active state`;
export const DisabledButtonsHeadingData: string = `Add <code>.disabled</code> class or <code>disabled="disabled"</code> attribute for disabled button`;
export const CustomStateButtonsHeadingData: string = `The <code>.btn</code> class used with <code>&lt;button&gt;</code>, <code>&lt;a&gt;</code> and <code>&lt;input&gt;</code> elements.`;
export const OutlineButtonsHeadingData: string = `Add <code>.btn-outline-*</code> class for border button`;
export const BoldBorderOutlineButtonsHeadingData: string = `Add <code>.btn-outline-*-2x</code> class for bold outline`;
export const OutlineLargeButtonsHeadingData: string = `Add <code>.btn-outline-*</code> class for outline and <code>.btn-lg</code> class for large button`;
export const OutlineSmallButtonsHeadingData: string = `Add <code>.btn-outline-*</code> class for outline and <code>.btn-sm</code> class for small button`;
export const OutlineExtraSmallButtonsHeadingData: string = `Add <code>.btn-outline-*</code> class for outline and <code>.btn-xs</code> class for extra small button`;
export const DisabledOutlineButtonsHeadingData: string = `Add <code>.disabled</code> class or <code>disabled="disabled"</code> attribute for disabled state`;
export const GraddienButtonsHeadingData: string = `Add <code>.btn-*-gradien</code> class for gradien button`;
export const BlogDetailsHeading: string = "Blog Details";
export const BlogPostHeading: string = "Add Post";
export const BlogHeading: string = "Blog";
export const FaqHeading: string = "FAQ";
export const GalleryHeading: string = "Gallery";
export const GalleryGridWithDescriptionHeading: string =
  "Gallery Grid With Description";
export const BlogSingleHeading: string = "Blog Single";
export const IMAGEGALLERY: string = "IMAGE GALLERY";
export const MasonryGalleryHeading: string = "Masonry Gallery";
export const ZeroConfigurationHeading: string = "Zero Configuration";
export const ZeroConfigurationSpan: string = ` DataTables has most features enabled by default, so all you need to do to use it with your own tables is to call the construction function:<code>$().DataTable();</code>.`;
export const ZeroConfigurationSpan2: string = `Searching, ordering and paging goodness will be immediately added to the table, as shown in this example.`;
export const StateSaving: string = `State saving`;
export const StateSavingSpan1: string = `DataTables has the option of being able to save the state of a table (its paging position, ordering state etc) so that is can be restored when the user reloads a page, or comes back to the page after visiting a sub-page. This state saving ability is enabled by the <code className="option">stateSave</code> option.`;
export const StateSavingSpan2: string = `The built in state saving method uses the HTML5 <code>localStorage</code> and <code>sessionStorage</code> APIs for efficient storage of the data. Please note that this means that the built in state saving option <strong>will not work with IE6/7</strong> as these browsers do not support these APIs. Alternative options of using cookies or saving the state on the server through Ajax can be used through the <code className="option">stateSaveCallback</code> and<a href="#javascript"><code className="option">stateLoadCallback</code></a>options.`;
export const StateSavingSpan3: string = `The duration for which the saved state is valid and can be used to restore the table state can be set using the <code className="option">stateDuration</code> initialisation parameter (2 hours by default). This parameter also controls if <code>localStorage</code> (0 or greater) or <code>sessionStorage</code> (-1) is used to store the data. `;
export const StateSavingSpan4: string = `The example below simply shows state saving enabled in DataTables with the <code className="option">stateSave</code> option.`;
export const DynamicHeight: string = `Scroll - vertical, dynamic height`;
export const DynamicHeightSpan1: string = ` This example shows a vertically scrolling DataTable that makes use of the CSS3 vh unit in order to dynamically resize the viewport based on the browser window height. The vh unit is effectively a percentage of the browser window height. So the 50vh used in this example is 50% of the window height. The viewport size will update dynamically as the window is resized.`;
export const DynamicHeightSpan2: string = ` A relatively modern browser is required for vh units to operate correctly. IE9+ supports the vh unit and all other evergreen browsers. `;
export const StockResult: string = `Stock Result`;
export const StockResultSpan1: string = `Data within DataTables can be easily rendered to add graphics orcolour to your tables, as demonstrated in the example on this page.These examples make use of columns.render and drawCallback tocustomise the cells in three ways:`;
export const StockResultSpan2: string = ` 1. the colour of the cell is determine by the relative price of the stock.`;
export const StockResultSpan3: string = `2. a 'sparkline' class is added to the numeric array in the 'last' column.`;
export const StockResultSpan4: string = ` 3. the jQuery Sparklines plugin is called to turn that array into a line graph.`;
export const AddRowsHeading: string = "Add rows";
export const AddRowsSpan1: string = `New rows can be added to a DataTable using the<code className="api" title="DataTables API method">row.add()</code> API method. Simply call the API function with the data for the new row (be it an array or object). Multiple rows can be added using the <code className="api">rows.add()</code> method (note the plural). Data can likewise be updated with the <code className="api"> row().data() </code> and <code className="api">row().remove()</code>methods.`;
export const AddRowsSpan2: string = ` Note that in order to see the new row in the table you must call the<code className="api"> draw() </code> method, which is easily done through the chaining that the DataTables API employs.`;
export const AddNewRow: string = "Add new row";
export const ChildrenRows: string =
  "Child rows (show extra / detailed information)";
export const ChildrenRowsSpan: string = ` The DataTables API has a number of methods for attaching child  to a parent row in the DataTable. This can be used to  additional information about a row, useful for cases where you  to convey more information about a row than there is space for  the host table.`;
export const RowsSelectionAndDeletion: string =
  "Row Selection And Deletion (Single Row)";
export const RowsSelectionSpan: string = ` It can be useful to provide the user with the option to select rows in a DataTable. This can be done by using a click event to add / remove a class on the table rows. The<code className="api"> rows().data()</code> method can then be used to get the data for the selected rows. In this case it is simply counting the number of selected rows, but much more complex interactions can easily be developed `;
export const DeleteSelectData: string = "Delete Selected Data..!";
export const DeleteRow: string = "Delete Row";
export const CustomFilteringSearch: string = "Custom filtering - range search";
export const MinimumAge: string = "Minimum age:";
export const MaximumAge: string = "Maximum age:";
export const CustomFilteringSearchSpan: string =
  "This example shows a search being performed on the age column in the data, based upon two inputs.";
export const HtmlTableTittle: string = "HTML (DOM) sourced data";
export const AjaxSourcedDataHeading: string = "Ajax sourced data";
export const JavaScriptTableSpan1: string = `At times you will wish to be able to create a table from dynamic information passed directly to DataTables, rather than having it read from the document. This is achieved using the <code class="option" title="DataTables initialisation option">data</code> option in the initialisation object, passing in an array of data to be used (like all other DataTables handled data, this can be arrays or objects using the<code class="option" title="DataTables initialisation option">columns.data</code> option).`;
export const JavaScriptTableSpan2: string = `A <code class="tag" title="HTML tag">table</code> must be available on the page for DataTables to use. This examples shows an empty <code class="tag" title="HTML tag">table</code> element being initialising as a DataTable with a set of data from a Javascript array. The columns in the table are dynamically created based on the <code class="option" title="DataTables initialisation option">columns.title</code>configuration option.`;
export const JavascriptSourcedDataHeading: string = "Javascript sourced data";
export const HtmlTableSpan: string = `The foundation for DataTables is progressive enhancement, so it is very adept at reading table information directly from the DOM. This example shows how easy it is to add searching, ordering and paging to your HTML table by simply running DataTables on it.`;
export const AjaxTableSpan: string = `DataTables has the ability to read data from virtually any JSON data source that can be obtained by Ajax. This can be done, in its most simple form, by setting the <code>ajax:option</code> option to the address of the JSON data source.`;
export const ServerSideProcessingHeading: string = "Server-side processing";
export const ServerSideProcessingSpan1: string = `There are many ways to get your data into DataTables, and if you are working with seriously large databases, you might want to consider using the server-side options that DataTables provides. With server-side processing enabled, all paging, searching, ordering actions that DataTables performs are handed off to a server where an SQL engine (or similar) can perform these actions on the large data set (after all, that's what the database engine is designed for!). As such, each draw of the table will result in a new Ajax request being made to get the required data.`;
export const ServerSideProcessingSpan2: string = `Server-side processing is enabled by setting the <code class="option" title="DataTables initialisation option">serverSide:option</code> option to <code>true</code> and providing an Ajax data source through the <code class="option" title="DataTables initialisation option">ajax:option</code> option.`;
export const RowCreateCallBackHeading: string = "Row Create Callback";
export const RowCreateCallBackSpan: string =
  " For each row that is generated for display, the createdRow function is called once and once only. It is passed the create row node which can then be modified.";
export const ID: string = "ID";
export const FullName: string = "Full name";
export const ExtraInfo: string = "Extra info";
export const ExtraInformation: string =
  "And any further details here (images etc)...";
export const AdvanceInitHeading: string = "Advance Init";
export const APIHeading: string = "API";
export const BasicInitHeading: string = "Basic DataTables";
export const DATASourceDataTables: string = "DATA Source DataTables";
export const SupportTicket: string = "Support Ticket List";
export const CKEditorExample: string = "CK Editor";
export const SecondExample: string = "Second Example";
export const SupportTicketSpan: string = "List of ticket opend by customers";
export const AustraliaMapText = "Below Map is displaying the Australia map.";
export const IndiaMapText: string = "Below Map is displaying the India map.";
export const USAMapText: string = "Below Map is displaying the USA map.";
export const worldMapText: string = "Below Map is displaying the world map.";
export const GoogleMaps: string = "Google Maps";
export const leafletMaps: string = "leaflet Maps";
export const Apps: string = "Apps";
export const SupportTicketHeading: string = "Support ticket";
export const AceEditorHeading: string = "ACE Code Editor";
export const CKEditorHeading: string = "Ck Editor";
export const MDEEditorHeading: string = "MDE Editor";
export const Editors: string = "Editors";
export const CardViewHeading: string = "Card View";
export const JobSearch: string = "Job Search";
export const JobApplyHeading: string = "Job Apply";
export const JobListHeading: string = "Job List";
export const JobDetailHeading: string = "Job detail";
export const LearningListHeading: string = "Learning List";
export const Learning: string = "Learning";
export const ProjectListHeading: string = "Project List";
export const NewProjectHeading: string = "Project Create";
export const Doing: string = "Doing";
export const CreateNewProject: string = "Create New Project";
export const Issues: string = "Issues";
export const Resolved: string = "Resolved";

// Project

export const ProjectTitle = "Project Title";
export const ClientName = "Client name";
export const ProjectRate = "Project Rate";

export const ProgressLevel = "Progress Level";
export const ProjectStatus = "Project Status";
export const ProjectSize = "Project Size";
export const Medium = "Medium";
export const Big = "Big";

export const StartingDate = "Starting date";
export const EndingDate = "Ending date";
export const EnterSomeDetails = "Enter some Details";
export const UploadProjectFile = "Upload project file";

export const FileManagerHeading: string = "File Manager";
export const kanBanBoardHeading: string = "kanBan Board";
export const ButtonTittle: string = "Button";
export const CustomButtons: string = "Custom state buttons";
export const Link: string = "Link";
export const ButtonHeading: string = "Button";
export const CustomButtonsSpan: string = `The <code>.btn</code> class used with <code>&lt;button&gt;</code>, <code>&lt;a&gt;</code> and <code>&lt;input&gt;</code> elements.`;
export const NestingButtonSpan: string = `Make nesting buttons`;
export const VerticalButtonSpan: string = `Make vertical buttons`;
export const SocialAppHeading: string = "Social App";
export const ActivityLogHeading = "Activity Log";
export const EducationAndEmploymentHeading = "Education and Employement";
export const FavouriteMusicBandsParagraph =
  "Breaking Good, RedDevil, People of Interest, The Running Dead, Found, American Guy.";
export const FavouriteTVShowsParagraph =
  "Breaking Good, RedDevil, People of Interest, The Running Dead, Found, American Guy.";
export const AboutMeParagraph =
  "Hi, I’m elana, I’m 30 and I work as a web Designer for the “Daydreams”  Agency in Pier 56.";
export const SocialNetworks = "Social Networks";
export const Dribbble = "Dribbble";
export const AddFriend = "Add Friend";
export const LatestPhoto = "Latest Photos";
export const Friends = "Friends";
export const TimelineParagraph =
  "The only way to do something in depth is to work hard. I've always thought of the T-shirt as the Alpha of the fashion alphabet. My breakfast is very important. Everything I do is a matter of heart, body and soul.";
export const JasonBorneParagraph =
  " we are working for the dance and sing songs. this car is very awesome for the youngster. please vote this car and like our post";
export const AlexendraDhadio = "Alexendra Dhadio";
export const AlexendraDhadioParagraph = `yes, really very awesome car i see the features of this car in the official website of #Mercedes-Benz and really impressed :-)`;
export const OliviaJon = "Olivia Jon";
export const IssaBell = "Issa Bell";
export const IssaBellParagraph =
  "we are working for the dance and sing songs. this car is very awesome for the youngster. please vote this car and like our post";
export const OliviaJonParagraph = `i like lexus cars, lexus cars are most beautiful with the awesome features, but this car is really outstanding than lexus`;
export const MoreCommnets = "More Commnets";
export const AnnaMull = "Anna Mull";
export const DionCast = "Dion Cast";
export const KarleneLex = "Karlene Lex";
export const VellaChism = "Vella Chism";
export const WaiSchalk = "Wai Schalk";
export const PepoleKnow = "Pepole You May Know";
export const ViewedYourProfile = "Viewed Your Profile";
export const HobbiesAndInterest = "Hobbies and Interests";
export const Hobbies = "Hobbies";
export const FavouriteGamesParagraph =
  "The First of Us, Assassin’s Squad, Dark Assylum, NMAK16, Last Cause 4, Grand Snatch Auto.";
export const OtherInterests = "Other Interests:";
export const OtherInterestsParagraph =
  "Swimming, Surfing, Scuba Diving, Anime, Photography, Tattoos, Street Art.";
export const FavouriteGames = "Favourite Games:";
export const FavouriteMovies = "Favourite Movies";
export const FavouriteMoviesParagraph = `Idiocratic, The Scarred Wizard and the Fire Crown, Crime Squad Ferrum Man.`;
export const FavouriteWriters = "Favourite Writers:";
export const FavouriteWritersParagraph = `Martin T. Georgeston, Jhonathan R. Token, Ivana Rowle, Alexandr Platt, Marcus Roth.`;
export const FavouriteBooks = "Favourite Books";
export const FavouriteBooksParagraph = `The Crime of the Century, Egiptian Mythology 101, The Scarred Wizard, Lord of the Wings, Amongst Gods, The Oracle, A Tale of Air and Water.`;
export const HobbiesParagraph = `I like to ride the bike to work, swimming, and working out. I also like reading design magazines, go to museums, and binge watching a good tv show while it’s raining outside.`;
export const FavouriteMusicBandsArtists = "Favourite Music Bands / Artists";
export const FavouriteMusicBandsArtistsParagraph = `Iron Maid, DC/AC, Megablow, The Ill, Kung Fighters, System of a Revenge.`;
export const TheNewCollegeOfDesign = "The New College of Design";
export const TheNewCollegeOfDesignParagraph =
  "Breaking Good, RedDevil, People of Interest, The Running Dead, Found, American Guy.";
export const DigitalDesignInternParagraph =
  "Digital Design Intern for the “Multimedz” agency. Was in charge of the communication with the clients.";
export const DigitalDesignIntern = "Digital Design Intern";
export const RembrandtInstitute = "Rembrandt Institute";
export const RembrandtInstituteParagraph =
  "Five months Digital Illustration course. Professor: Leonardo Stagg.";
export const UIUXDesignerParagraph =
  "Breaking Good, RedDevil, People of Interest, The Running Dead, Found, American Guy.";
export const TheNewCollegeOfDesignParagraph2 =
  "UI/UX Designer for the “Daydreams” agency.";
export const AboutMe = "About Me";
export const JohnyWaston = "Johny Waston";
export const AndewJon = "Andew Jon";
export const BuckyBarnes = "Bucky Barnes";
export const MutualFriend = "Mutual Friends";
export const SarahLoren = "Sarah Loren";
export const JohnyWilliam = "Johny William";
export const Ago = "Ago";
export const Photo = "Photo";
export const CommentedOn = "Commented on";
export const ProfileIntro = "Profile Intro";
export const FavouriteTVShows = "Favourite TV shows";
export const FavouriteMusicBands = "Favourite Music Bands ";
export const JasonBorne = "Jason Borne";
export const ComerenDiaz = "Comeren Diaz";
export const UXUIDesigner = "UI/UX Designer";
export const TheDigitalCollege = "The Digital College";
export const TheDigitalCollegeParagraph =
  "6 months intensive Motion Graphics course. After Effects and Premire. Professor: Donatello Urtle.";
export const MyProfile = "My Profile";
export const Likes = "Likes";
export const Messages = "Messages";
export const MyPage = "My Page";
export const Notification = "Notification";
export const NewLikesThisWeek = "New Likes This Week";
export const Followers = "Followers";
export const Facebook = "Facebook";
export const ELANAHeading = "ELANA";
export const Photos = "Photos";
export const photoDescription =
  "is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.";
export const BookMarksHeading: string = "Bookarks";
export const NewBookmark = "New Bookmark";

export const Projects = "PROJECTS";
export const marketinExpenses = "Marketing Expenses";
export const totalSales = "Total sales";
export const totalPurchase = "Total Purchase";
export const totalEarning = "Total Earning";
export const year = "Year";
export const month = "Month";
export const today = "Today";
export const skillStatus = "Skill Status";
export const orderStatus = "Order Status";
export const liveProducts = "Live Products";
export const turnover = "Turnover";
export const monthlySales = "Monthly Sales";
export const uses = "Uses";
export const browserUses = "Browser Uses";
export const finance = "Finance";
export const ClipBoardCopy = "Copy Portion From Paragraph";
export const Highlight = "dolor ertrsiertertt amet";
export const CopyHighLightedText = "Copy highlighted text";
export const CutcopyFromTextInput = "Cut/copy from text input";
export const OneValue = "Select One Value Only";
export const sales = "Sales";
export const salesByMonth = "Sales By Month";
export const AddBookmark = "Add Bookmark";
export const EditBookmark = "Edit Bookmark";
export const MyBookmark = " My bookmark";
export const WebUrl = "Web Url";
export const Group = "Group";
export const MyBookmarks = "My Bookmarks";
export const Favourites = "Favourites";
export const SharedWithMe = "Shared with me";
export const Important = "Important";
export const Orgenization = "Organization";
export const NoBookmarksFound = "No Bookmarks Found.";
export const UserCards: string = "User Cards";
export const UserEdit: string = "Edit Profile";
export const UserProfile: string = "User Profile";
export const Users: string = "Users";
export const Designer: string = "Designer";
export const UpdateProfile: string = "UpdateProfile";
export const PostalCode: string = "Postal Code";
export const Germany: string = "Germany";
export const EditProfile: string = "Edit Profile";
export const Address: string = "Address";
export const Aus: string = "Aus";
export const Canada: string = "Canada";
export const Usa: string = "Usa";
export const ProjectName: string = "Project Name";
export const AddprojectAndUpload: string = "Add project And Upload";
export const Edit: string = "Edit";
export const Update: string = "Update";
export const TotalPost: string = "Total Post";
export const UntrammelledPrevents: string = "UntrammelledPrevents";
export const Posts: string = "Posts";
export const TaskListHeading: string = "Tasks";

// task
export const NewTask = "New Task";
export const TaskTitle = "Task Title";
export const TodayTasks = "Today's Tasks";
export const DelayedTasks = "Delayed Tasks";
export const UpcomingTasks = "Upcoming Tasks";
export const ThisWeekTask = "This week tasks";
export const AssignedToMe = "Assigned to me";
export const MyTasks = "My tasks";
export const ThisMonthTasks = "This month tasks";
export const NoTaskDueToday = "No task due today.";
export const NoTasksFound = "No tasks found.";

export const EmailFilter = "Email Filter";
export const MARKJENCO = "MARK JENCO";
export const NEWMAIL = "NEW MAIL";
export const AllMail = "All mail";
export const Sent = "Sent";
export const Draft = "Draft";
export const Trash = "Trash";
export const TrashList = "Trash List";

export const IMPORTANT = "IMPORTANT";
export const Starred = "Starred";
export const UNREAD = "UNREAD";
export const Spam = "Spam";
export const OUTBOX = "OUTBOX";
export const UPDATE = "UPDATE";
export const ALERT = "ALERT";
export const NOTES = "NOTES";
export const NoMailFound = "No mail found";
export const NewMessage = "New Message";
export const SendMessage = "Send Message";
export const To = "To";
export const ATTACHMENTS = "ATTACHMENTS";
export const DownloadAll = "Download All";
export const Reply = "Reply";
export const ReplyAll = "Reply All";
export const Forward = "Forward";
export const More = "More";
export const Subject = "Subject";
export const Refresh = "Refresh";
export const Markasimportant = "Mark as important";
export const Movetospam = "Move to spam";
export const MovetoTrash = "Move to Trash";
export const Lormipsa = "John Deo";
export const Lormdisc = "Inquiry about our theme pages design.";
export const DearSirGoodMorning = "Dear Sir Good Morning,";
export const Elementumvarius = "Inquiry about our theme pages design.";
export const Lorem =
  "xolo Admin is a full featured, multipurpose, premium bootstrap admin template built with Bootstrap 5 Framework, HTML5, CSS and JQuery.It has a huge collection of reusable UI components and integrated with latest jQuery plugins.";
export const Lorem2 =
  "Dressing is a way of life. My customers are successful working women. I want people to be afraid of the women I dress. Age is something only in your head or a stereotype. Age means nothing when you are passionate about something. There has to be a balance between your mental satisfaction and the financial needs of your company. I want people to be afraid of the women I dress.";
export const Emailpara =
  "It can be used for all type of Web applications like custom admin panel, app backend, CMS or CRM. UI components and integrated with latest jQuery plugins. Koho Admin is a full featured, multipurpose, premium bootstrap admin template built with Bootstrap 5 Framework.";
export const NewMail = "NEW MAIL";
export const MarkAsImportant = "Mark as important";
export const MoveToSpam = "Move to spam";
export const MoveToTrash = "Move to Trash";
export const PorkLorn = "Pork Lorn";
export const LormLpsa = "Lorm lpsa";
export const HileriMakr = "Hileri Makr";
export const LionLorpa = "Lion Lorpa";
export const SolvnRelto = "Solvn Relto";
export const ReproSoft = "Repro Soft";
export const CreatedByMe = "Created By Me";
export const Newsletter = "News letter";
export const Holidays = "Holidays";
export const Views = "Views";
export const Tags = "Tags";
export const Print = "Print";
export const Save = "Save";
export const MARKJENCOEMAIL = "Markjecno@gmail.com";
export const CalenderHeading = "calender Basic";
export const AppsHeading = "Apps";

export const DraggableEvents = "Draggable Events";
export const RemoveAfterDrop = "remove after drop";
export const SearchWebsite: string = `Search Website`;
export const SearchPages: string = `Search Pages`;
export const AllAbout: string = `About 6,000 results (0.60 seconds)`;
export const ImageAbout: string = "About 12,120 results (0.50 seconds)";
export const ToDoHeading: string = "To-Do";
export const Todo: string = "To-Do";
export const AddTask: string = "Add Task";
export const AddNewTask: string = "Add New Task";
export const ToDoFilter: string = "To Do filter";
export const MarkJecnoEmail: string = "Markjecno@gmail.com";
export const ToDoList: string = "To Do List";
export const Search: string = "Search";
export const SearchPixelStrap: string = `Search result for "Pixelstrap"`;
export const Business = "Business";
export const ContactHistory = "Contact History";
export const ContactCreated = "Contact Created";
export const NewContacts = "New Contacts";
export const AddContacts = " Add Contact";
export const Mobile = "Mobile";
export const MobileNo = "Mobile No";
export const AddCategory = "Add Category";
export const FollowUp = "Follow up";
export const Ideas = "Ideas";
export const History = "History";
export const NoDataFound = "No Data Found";
export const Gender = "Gender";
export const PrintViews = "Print preview";
export const Work = "Work";
export const Other = "Other";
export const Personal = "Personal";
export const SignUpToAccount: string = `Sign Up To Account`;
export const EmailPassWord: string = `Enter your email & password to login`;
export const Birthday: string = `Birthday:`;
export const MAINTENANCE: string = `MAINTENANCE`;

export const PlanSpace: string = "Plan Space";
export const Plan200gb: string = " 200 GB Space";
export const FREE: string = "FREE";
export const Premium: string = "Premium";
export const PricingPlan: string = "Pricing Plan";
export const Selected: string = "Selected";
export const TrialVersion: string = "Trial Version";
export const FileFilter: string = "File filter";
export const AddNew: string = "Add New";
export const AllFiles: string = "All Files";
export const Files: string = "Files";
export const Storage: string = "Storage";
export const PricePlan: string = "$5/month";
export const Folders: string = "Folders";
export const LastOpen: string = "last open : ";
export const QuickAcces: string = "Quick Access ";
export const RecentlyOpenedFiles: string = "Recently opened files";
export const Pinned: string = `Pinned`;
export const SirName: string = `Sir Name`;
export const ContactHeading: string = `Contacts`;
export const POS: string = `POS`;
export const DisabledCheckedCheckBox: string = `Disabled Checked CheckBox`;
export const DisabledReverseCheckBox: string = `Disabled Reverse CheckBox`;
export const ReverseCheckBox: string = `Reverse CheckBox`;
export const RightChecks: string = `Right Checks`;
export const IndeterminateCheckBox: string = `Indeterminate CheckBox`;
export const IndeterminateHeading: string = `Indeterminate`;
export const CustomCheckBoxHeading: string = `Custom CheckBox`;
export const BorderedCheckBoxHeading: string = `Bordered CheckBox`;
export const IconCheckBoxHeading: string = `Icon CheckBox`;
export const FilledCheckBoxHeading: string = `Filled Checkbox`;
export const DefaultRadioHeading: string = `Default Radio`;
export const CustomRadiosHeading: string = "Custom Radios";
export const DefaultCheckedRadio: string = "Default Checked Radio";
export const DefaultRadio: string = "Default Radio";
export const DisabledCheckedRadio: string = "Disabled Checked Radio";
export const DisabledRadio: string = "Disabled Radio";
export const DisabledRadiosHeading: string = "Disabled Radios";
export const RightRadiosHeading: string = "Right Radios";
export const ImagesWithCheckBoxHeading: string = "Images With CheckBox";
export const ImagesWithRadioBoxHeading: string = "Images With RadioBox";
export const CustomRadioBoxHeading: string = "Custom RadioBox";
export const DefaultSwitchesBoxHeading: string = "Default Switches Box";
export const CheckedSwitchCheckboxInput: string =
  "CheckedSwitch Checkbox Input";
export const CustomSwitches: string = "Custom Switches";
export const DefaultSwitchCheckboxInput: string =
  "Default Switch CheckboxInput";
export const DisabledCheckedSwitchCheckboxInput: string =
  "Disabled Checked Switch Checkbox Input";
export const DisabledSwitchCheckboxInput: string =
  "Disabled Switch CheckboxInput";
export const DisabledSwitches: string = "Disabled Switches";
export const BorderedRadioBoxHeading: string = "Bordered Radio Box";
export const FilledRadioBoxHeading: string = "Filled Radio Box";
export const IconRadioBoxHeading: string = "Icon Radio Box";
export const QrCodeAlertText: string =
  "If your qr code is not working then enter this code in your input field.";
export const ScrollableDropDownMenu: string = "Scrollable Drop Down Menu";
export const Firstname: string = "First name";
